// Auto-generated by backend/generate_hajj_timeline.py — 11-language Hajj day-by-day timeline.
export const HAJJ_STATIONS = [
  {
    "id": "tarwiyah",
    "day": "8",
    "status": "sunnah",
    "loc": "mina",
    "arabic": "لَبَّيْكَ اللَّهُمَّ حَجًّا",
    "translit": "Labbaika-llāhumma hajjā",
    "title": {
      "id": "Hari Tarwiyah — Menuju Mina",
      "en": "The Day of Tarwiyah — Heading to Mina",
      "ar": "يوم التروية — التوجه إلى منى",
      "fr": "Le Jour de Tarwiyah — En Route vers Mina",
      "de": "Der Tag von Tarwiyah — Aufbruch nach Mina",
      "es": "El Día de Tarwiyah — Rumbo a Mina",
      "ru": "День Тарвийи — Путь к Мине",
      "zh": "塔尔维叶日 — 前往米纳",
      "ja": "タルウィヤの日 — ミナーへ向かう",
      "ko": "타르위야의 날 — 미나로 향하며",
      "hi": "तर्वियह का दिन — मिना की ओर प्रस्थान"
    },
    "body": [
      {
        "id": "Jamaah haji Tamattu' kembali berihram untuk haji dari tempat tinggalnya di Makkah dan berniat: Labbaika-llāhumma hajjan.",
        "en": "Hajj Tamattu' pilgrims re-enter Ihram for Hajj from their place of residence in Makkah and make the intention: Labbaika-llāhumma hajjan.",
        "ar": "يُحرم حجاج التمتع للحج من أماكن إقامتهم في مكة المكرمة وينوون قائلين: لبيك اللهم حجاً.",
        "fr": "Les pèlerins du Hajj Tamattu' revêtent à nouveau l'Ihram pour le Hajj depuis leur lieu de résidence à La Mecque et formulent l'intention : Labbaika-llāhumma hajjan.",
        "de": "Die Hajj-Tamattu'-Pilger nehmen erneut Ihram für den Hajj von ihrer Unterkunft in Makkah an und sprechen die Absicht aus: Labbaika-llāhumma hajjan.",
        "es": "Los peregrinos del Hajj Tamattu' vuelven a entrar en Ihram para el Hajj desde su lugar de residencia en La Meca y formulan la intención: Labbaika-llāhumma hajjan.",
        "ru": "Паломники Хаджж Таматту' вновь облачаются в Ихрам для Хаджжа из своих мест проживания в Макке и произносят намерение: Labbaika-llāhumma hajjan.",
        "zh": "享受朝（Tamattu'）的朝觉者在麦加居所重新穿上戒衣（Ihram）进行朝觐，并发念: Labbaika-llāhumma hajjan。",
        "ja": "ハッジ・タマットゥの巡礼者はマッカの宿泊場所からハッジのためにイフラームを再び結び、次の意図を唱える：Labbaika-llāhumma hajjan。",
        "ko": "핫즈 타맛투' 순례자들은 마카에서 머무는 곳에서 핫즈를 위해 다시 이흐람을 입고 다음과 같이 의도를 선언한다: Labbaika-llāhumma hajjan.",
        "hi": "हज्ज तमत्तु' के हाजी मक्का में अपने निवास स्थान से हज्ज के लिए पुनः इहराम बाँधते हैं और नीयत करते हैं: Labbaika-llāhumma hajjan।"
      },
      {
        "id": "Pada pagi hari, jamaah bertolak menuju Mina dan menetap (mabit) di sana.",
        "en": "In the morning, the pilgrims set out for Mina and stay overnight (mabit) there.",
        "ar": "في صباح اليوم الثامن، ينطلق الحجاج إلى منى ويبيتون فيها.",
        "fr": "Au matin, les pèlerins se dirigent vers Mina et y passent la nuit (mabit).",
        "de": "Am Morgen brechen die Pilger nach Mina auf und verbringen die Nacht (Mabit) dort.",
        "es": "Por la mañana, los peregrinos parten hacia Mina y pernoctan (mabit) allí.",
        "ru": "Утром паломники отправляются в Мину и ночуют (мабит) там.",
        "zh": "清晨，朝觉者启程前往米纳，并在那里留宿（Mabit）。",
        "ja": "朝になると、巡礼者たちはミナーへ出発し、そこで一夜を過ごす（マビート）。",
        "ko": "아침에 순례자들은 미나로 출발하여 그곳에서 마비트(Mabit, 야영)를 한다.",
        "hi": "सुबह होते ही हाजी मिना के लिए रवाना होते हैं और वहाँ रात गुजारते हैं (मबीत)।"
      },
      {
        "id": "Mengerjakan shalat Zuhur, Ashar, Maghrib, Isya, dan Subuh di Mina secara qashar (diringkas) tanpa dijamak, sebagaimana tuntunan Nabi ﷺ.",
        "en": "The prayers of Zuhr, Asr, Maghrib, Isha, and Fajr are performed in Mina in a shortened form (qashar) without combining them, as was the guidance of the Prophet ﷺ.",
        "ar": "تُؤدَّى صلوات الظهر والعصر والمغرب والعشاء والفجر في منى مقصورةً دون جمع، اتباعاً لهدي النبي ﷺ.",
        "fr": "Les prières de Zuhr, Asr, Maghrib, Isha et Fajr sont accomplies à Mina en mode abrégé (qashar) sans les regrouper, conformément à la guidance du Prophète ﷺ.",
        "de": "Die Gebete Zuhr, Asr, Maghrib, Isha und Fajr werden in Mina in verkürzter Form (Qashar) ohne Zusammenlegung verrichtet, gemäß der Weisung des Propheten ﷺ.",
        "es": "Las oraciones de Zuhr, Asr, Maghrib, Isha y Fajr se realizan en Mina en forma abreviada (qashar) sin combinarlas, siguiendo la guía del Profeta ﷺ.",
        "ru": "Молитвы Зухр, Аср, Магриб, Иша и Фаджр совершаются в Мине в сокращённой форме (касар) без объединения, следуя наставлению Пророка ﷺ.",
        "zh": "在米纳，晌礼（Zuhr）、晡礼（Asr）、昏礼（Maghrib）、宵礼（Isha）和晨礼（Fajr）均以缩短方式（Qashar）礼拜，不合并礼拜，遵循先知ﷺ的指导。",
        "ja": "ミナーでは、ズフル、アスル、マグリブ、イシャー、ファジュルの礼拝を、合わせることなく短縮（カスル）して行う。これは預言者ﷺの指導に従うものである。",
        "ko": "미나에서는 주흐르, 아스르, 마그립, 이샤, 파즈르 예배를 합치지 않고 단축(카스르)하여 드리니, 이는 예언자ﷺ의 가르침을 따른 것이다.",
        "hi": "मिना में जुह्र, अस्र, मगरिब, इशा और फज्र की नमाजें कस्र (संक्षिप्त) रूप में अदा की जाती हैं, उन्हें जमा किए बिना — जैसा कि नबी ﷺ की सुन्नत है।"
      }
    ],
    "dua": {
      "id": "Aku penuhi panggilan-Mu, ya Allah, untuk menunaikan haji.",
      "en": "I answer Your call, O Allah, to perform Hajj.",
      "ar": "لبيك اللهم حجاً.",
      "fr": "Me voici à Ton appel, ô Allah, pour accomplir le Hajj.",
      "de": "Ich beantworte Deinen Ruf, o Allah, um den Hajj zu verrichten.",
      "es": "Aquí estoy respondiendo a Tu llamado, oh Allah, para realizar el Hajj.",
      "ru": "Я отвечаю на Твой зов, о Аллах, чтобы совершить Хаджж.",
      "zh": "我应答您的召唤，啊安拉，为了履行朝觐。",
      "ja": "アッラーよ、私はあなたの呼びかけに応え、ハッジを行うために参りました。",
      "ko": "오 알라여, 하즈를 수행하기 위해 당신의 부름에 응답합니다.",
      "hi": "मैं आपकी पुकार पर हाजिर हूँ, या अल्लाह, हज्ज अदा करने के लिए।"
    },
    "evidence": {
      "id": "HR. Muslim no. 1218 (hadits Jabir tentang tata cara haji Nabi ﷺ).",
      "en": "HR. Muslim no. 1218 (the hadith of Jabir regarding the method of the Prophet's ﷺ Hajj).",
      "ar": "أخرجه مسلم برقم 1218 (حديث جابر في صفة حجة النبي ﷺ).",
      "fr": "HR. Muslim n° 1218 (le hadith de Jabir concernant la méthode du Hajj du Prophète ﷺ).",
      "de": "HR. Muslim Nr. 1218 (der Hadith von Jabir über die Art und Weise des Hajj des Propheten ﷺ).",
      "es": "HR. Muslim n.º 1218 (el hadiz de Jabir sobre el método del Hajj del Profeta ﷺ).",
      "ru": "Муслим № 1218 (хадис Джабира о порядке совершения Хаджжа Пророком ﷺ).",
      "zh": "穆斯林圣训集第1218条（贾比尔关于先知ﷺ朝觐方式的圣训）。",
      "ja": "ムスリム集 第1218番（ジャービルによる預言者ﷺのハッジの作法に関するハディース）。",
      "ko": "HR. 무슬림 No. 1218 (예언자ﷺ의 핫즈 방법에 관한 자비르의 하디스).",
      "hi": "HR. मुस्लिम नं. 1218 (जाबिर की हदीस जो नबी ﷺ के हज्ज के तरीके के बारे में है)।"
    }
  },
  {
    "id": "arafah",
    "day": "9",
    "status": "rukun",
    "loc": "arafah",
    "arabic": "لَا إِلَٰهَ إِلَّا اللَّهُ وَحْدَهُ لَا شَرِيكَ لَهُ، لَهُ الْمُلْكُ وَلَهُ الْحَمْدُ وَهُوَ عَلَىٰ كُلِّ شَيْءٍ قَدِيرٌ",
    "translit": "Lā ilāha illa-llāhu waḥdahu lā syarīka lah, lahu-l-mulku wa lahu-l-ḥamdu wa huwa ‘alā kulli syai’in qadīr",
    "title": {
      "id": "Wukuf di Arafah",
      "en": "Wuquf at Arafah",
      "ar": "الوقوف بعرفة",
      "fr": "Wuqûf à Arafah",
      "de": "Wuquf in Arafah",
      "es": "Wuquf en Arafah",
      "ru": "Вукуф на Арафате",
      "zh": "在阿拉法特山站立（Wuquf）",
      "ja": "アラファートでのウクーフ（Wuquf）",
      "ko": "아라파트에서의 우쿠프（Wuquf）",
      "hi": "अराफ़ाह में वुकूफ़ (Wuquf)"
    },
    "body": [
      {
        "id": "Wukuf di Arafah adalah rukun haji terbesar; tanpanya haji tidak sah. Waktunya sejak matahari tergelincir (Zuhur) 9 Dzulhijjah hingga terbit fajar 10 Dzulhijjah.",
        "en": "Wuquf at Arafah is the greatest pillar of Hajj; without it, Hajj is invalid. Its time spans from the sun's decline (Zuhr) on the 9th of Dhul-Hijjah until the dawn of the 10th of Dhul-Hijjah.",
        "ar": "الوقوف بعرفة هو أعظم أركان الحج؛ فمن فاته فقد فاته الحج. ويمتد وقته من زوال الشمس (الظهر) في اليوم التاسع من ذي الحجة حتى طلوع فجر اليوم العاشر منه.",
        "fr": "Le Wuqûf à Arafah est le pilier le plus important du Hajj ; sans lui, le Hajj est invalide. Son temps s'étend du déclin du soleil (Zuhr) le 9 Dhul-Hijjah jusqu'à l'aube du 10 Dhul-Hijjah.",
        "de": "Der Wuquf in Arafah ist der größte Pfeiler des Hajj; ohne ihn ist der Hajj ungültig. Seine Zeit erstreckt sich vom Sonnenmittagsstand (Zuhr) am 9. Dhul-Hijjah bis zum Morgengrauen des 10. Dhul-Hijjah.",
        "es": "El Wuquf en Arafah es el pilar más grande del Hajj; sin él, el Hajj no es válido. Su tiempo abarca desde el declive del sol (Zuhr) el 9 de Dhul-Hijjah hasta el amanecer del 10 de Dhul-Hijjah.",
        "ru": "Вукуф на Арафате — величайший столп Хаджа; без него Хадж недействителен. Его время длится с полудня (Зухр) 9-го Зуль-Хиджжа до рассвета 10-го Зуль-Хиджжа.",
        "zh": "在阿拉法特山的站立（Wuquf）是朝觐（Hajj）最重要的支柱，缺少它朝觐便无效。其时间从杜勒·海贾月（Dhul-Hijjah）9日正午（Zuhr）太阳偏斜时开始，至10日黎明为止。",
        "ja": "アラファートでのウクーフ（Wuquf）はハッジ（Hajj）の最大の柱であり、これなくしてはハッジは成立しません。その時間はズルヒッジャ月（Dhul-Hijjah）9日の正午（Zuhr）の日没から10日の夜明けまで続きます。",
        "ko": "아라파트에서의 우쿠프（Wuquf）는 하즈（Hajj）의 가장 중요한 기둥으로, 이것이 없으면 하즈는 무효입니다. 그 시간은 줄히자（Dhul-Hijjah）월 9일 정오（Zuhr）의 태양이 기울 때부터 10일 새벽까지 이어집니다.",
        "hi": "अराफ़ाह में वुकूफ़ (Wuquf) हज का सबसे बड़ा रुक्न है; इसके बिना हज मान्य नहीं होता। इसका समय ज़ुल-हिज्जा (Dhul-Hijjah) की 9 तारीख को सूर्य के ढलने (ज़ुहर) से लेकर 10 तारीख की भोर तक होता है।"
      },
      {
        "id": "Shalat Zuhur dan Ashar dijamak-qashar (jamak taqdim) di waktu Zuhur, lalu jamaah memperbanyak doa, dzikir, istighfar, dan talbiyah menghadap kiblat.",
        "en": "The Zuhr and Asr prayers are combined and shortened (Jam' Taqdim) at Zuhr time, after which the pilgrims abundantly engage in supplication (du'a), dhikr, istighfar, and Talbiyah while facing the Qiblah.",
        "ar": "تُجمع صلاتا الظهر والعصر جمع تقديم مع القصر في وقت الظهر، ثم يُكثر الحجاج من الدعاء والذكر والاستغفار والتلبية مستقبلين القبلة.",
        "fr": "Les prières de Zuhr et de Asr sont combinées et raccourcies (Jam' Taqdim) à l'heure du Zuhr, puis les pèlerins multiplient les invocations (du'a), le dhikr, l'istighfar et la Talbiyah en se tournant vers la Qiblah.",
        "de": "Die Zuhr- und Asr-Gebete werden zur Zuhr-Zeit verkürzt und zusammengelegt (Jam' Taqdim), danach verrichten die Pilger reichlich Bittgebet (Du'a), Dhikr, Istighfar und Talbiyah in Richtung der Qiblah.",
        "es": "Las oraciones de Zuhr y Asr se combinan y acortan (Jam' Taqdim) en el tiempo del Zuhr, tras lo cual los peregrinos se dedican abundantemente a la súplica (du'a), el dhikr, el istighfar y la Talbiyah mirando hacia la Qiblah.",
        "ru": "Молитвы Зухр и Аср объединяются и сокращаются (Джам' Такдим) во время Зухра, после чего паломники усердно совершают мольбы (ду'а), зикр, истигфар и Тальбию, обратившись лицом к Кибле.",
        "zh": "晌礼（Zuhr）与晡礼（Asr）合并缩短（Jam' Taqdim）在晌礼时间内礼拜，之后朝觐者面朝朝拜方向（Qiblah）大量进行祈祷（du'a）、念诵（dhikr）、求恕（istighfar）及应召词（Talbiyah）。",
        "ja": "ズフル（Zuhr）とアスル（Asr）の礼拝はズフルの時間に短縮・合同（Jam' Taqdim）して行われ、その後、巡礼者たちはキブラ（Qiblah）に向かって祈り（du'a）、ズィクル（dhikr）、イスティグファール（istighfar）、タルビヤ（Talbiyah）を多く唱えます。",
        "ko": "주흐르（Zuhr）와 아스르（Asr） 예배는 주흐르 시간에 단축 및 합병（Jam' Taqdim）하여 드리고, 이후 순례자들은 키블라（Qiblah）를 향해 두아（du'a）, 지크르（dhikr）, 이스티그파르（istighfar）, 탈비야（Talbiyah）를 풍성하게 행합니다.",
        "hi": "ज़ुहर और अस्र की नमाज़ें ज़ुहर के वक्त जमा-क़स्र (Jam' Taqdim) के साथ पढ़ी जाती हैं, फिर हाजी क़िब्ला (Qiblah) की तरफ मुँह करके दुआ, ज़िक्र, इस्तिग़फार और तलबिया (Talbiyah) की अधिकता करते हैं।"
      },
      {
        "id": "Inilah hari paling utama untuk berdoa; Nabi ﷺ bersabda sebaik-baik doa adalah doa hari Arafah.",
        "en": "This is the most virtuous day for supplication; the Prophet ﷺ said: \"The best du'a is the du'a of the Day of Arafah.\"",
        "ar": "هذا هو أفضل يوم للدعاء؛ قال النبي ﷺ: «خير الدعاء دعاء يوم عرفة».",
        "fr": "C'est le jour le plus méritoire pour l'invocation ; le Prophète ﷺ a dit : « La meilleure des invocations est l'invocation du jour d'Arafah. »",
        "de": "Dies ist der vorzüglichste Tag für das Bittgebet; der Prophet ﷺ sagte: „Das beste Du'a ist das Du'a am Tag von Arafah.\"",
        "es": "Este es el día más virtuoso para la súplica; el Profeta ﷺ dijo: \"La mejor du'a es la du'a del Día de Arafah.\"",
        "ru": "Это наилучший день для мольбы; Пророк ﷺ сказал: «Лучшая ду'а — это ду'а дня Арафата».",
        "zh": "这是祈祷最具价值的一天；先知ﷺ说：\"最好的祈祷是阿拉法特日的祈祷。\"",
        "ja": "これは最も優れた祈りの日であり、預言者ﷺは「最善のドゥアーはアラファートの日のドゥアーである」と仰いました。",
        "ko": "이날은 두아（du'a）에 가장 탁월한 날이며, 예언자ﷺ께서는 \"가장 훌륭한 두아는 아라파트의 날의 두아이다\"라고 말씀하셨습니다.",
        "hi": "यह दुआ के लिए सबसे श्रेष्ठ दिन है; नबी ﷺ ने फरमाया: \"सबसे बेहतरीन दुआ अराफ़ाह के दिन की दुआ है।\""
      }
    ],
    "dua": {
      "id": "Tiada tuhan selain Allah semata, tiada sekutu bagi-Nya; milik-Nya kerajaan dan segala puji, dan Dia Mahakuasa atas segala sesuatu.",
      "en": "There is no god but Allah alone, with no partner; His is the dominion and all praise, and He is Omnipotent over all things.",
      "ar": "لَا إِلَهَ إِلَّا اللهُ وَحْدَهُ لَا شَرِيكَ لَهُ، لَهُ الْمُلْكُ وَلَهُ الْحَمْدُ، وَهُوَ عَلَى كُلِّ شَيْءٍ قَدِيرٌ.",
      "fr": "Il n'y a de dieu qu'Allah seul, sans associé ; à Lui appartient le royaume et toute louange, et Il est Omnipuissant sur toute chose.",
      "de": "Es gibt keinen Gott außer Allah allein, ohne Teilhaber; Ihm gehört die Herrschaft und aller Lobpreis, und Er ist allmächtig über alle Dinge.",
      "es": "No hay más dios que Allah solo, sin asociado; Suyo es el reino y toda alabanza, y Él es Omnipotente sobre todas las cosas.",
      "ru": "Нет божества, кроме Аллаха единого, нет у Него сотоварища; Ему принадлежит власть и вся хвала, и Он над всякой вещью мощен.",
      "zh": "万物非主，唯有真主，独一无二，无有伙伴；国度属于祂，赞美属于祂，祂对一切事物无所不能。",
      "ja": "アッラーの他に神はなく、ただ御一方のみ、御方には配偶者なし。支配と賛美はすべて御方のもの、御方はあらゆることに全能であられる。",
      "ko": "알라 외에 신은 없으며, 그분은 홀로이시고 동반자가 없으시다. 지배권과 모든 찬미는 그분의 것이며, 그분은 모든 것에 전능하시다.",
      "hi": "अल्लाह के सिवा कोई पूज्य नहीं, वह अकेला है, उसका कोई साझी नहीं; राज्य उसी का है और तमाम तारीफ़ें उसी के लिए हैं, और वह हर चीज़ पर क़ादिर है।"
    },
    "evidence": {
      "id": "«Haji itu (wukuf di) Arafah» (HR. Tirmidzi no. 889). Sebaik-baik doa: HR. Tirmidzi no. 3585. Lihat pula QS. Al-Baqarah: 198–199.",
      "en": "\"Hajj is (Wuquf at) Arafah\" (Tirmidhi no. 889). The best du'a: Tirmidhi no. 3585. See also Qur'an Al-Baqarah: 198–199.",
      "ar": "«الحج عرفة» (رواه الترمذي، رقم 889). وفي فضل دعاء يوم عرفة: الترمذي، رقم 3585. انظر أيضاً: سورة البقرة: 198–199.",
      "fr": "« Le Hajj, c'est (le Wuqûf à) Arafah » (Tirmidhi n° 889). La meilleure du'a : Tirmidhi n° 3585. Voir aussi le Coran, Al-Baqarah : 198–199.",
      "de": "„Der Hajj ist (der Wuquf in) Arafah\" (Tirmidhi Nr. 889). Bestes Du'a: Tirmidhi Nr. 3585. Siehe auch Qur'an Al-Baqarah: 198–199.",
      "es": "«El Hajj es (el Wuquf en) Arafah» (Tirmidhi n.º 889). La mejor du'a: Tirmidhi n.º 3585. Véase también el Corán, Al-Baqarah: 198–199.",
      "ru": "«Хадж — это (Вукуф на) Арафат» (Тирмизи, № 889). Лучшая ду'а: Тирмизи, № 3585. См. также Коран, Аль-Бакара: 198–199.",
      "zh": "\"朝觐就是（在）阿拉法特（的站立）\"（提尔米济 Tirmidhi，第889条）。最好的祈祷：提尔米济第3585条。另见《古兰经》雌牛章（Al-Baqarah）：198–199。",
      "ja": "「ハッジとはアラファートでの（ウクーフ）である」（ティルミジー Tirmidhi 第889番）。最善のドゥアー：ティルミジー第3585番。クルアーン アル=バカラ章：198–199も参照。",
      "ko": "\"하즈는 아라파트에서의 (우쿠프)이다\" (티르미디 Tirmidhi 889번). 최선의 두아: 티르미디 3585번. 꾸란 알-바카라(Al-Baqarah): 198–199도 참조하십시오.",
      "hi": "\"हज (अराफ़ाह में) वुकूफ़ है\" (तिर्मिज़ी Tirmidhi, क्र. 889)। सर्वोत्तम दुआ: तिर्मिज़ी क्र. 3585। देखें क़ुरआन अल-बक़रा (Al-Baqarah): 198–199।"
    }
  },
  {
    "id": "muzdalifah",
    "day": "9",
    "status": "wajib",
    "loc": "muzdalifah",
    "arabic": "",
    "translit": "",
    "title": {
      "id": "Mabit di Muzdalifah",
      "en": "Staying Overnight (Mabit) in Muzdalifah",
      "ar": "المبيت في مزدلفة",
      "fr": "Mabit à Muzdalifah",
      "de": "Mabit in Muzdalifah",
      "es": "Mabit en Muzdalifah",
      "ru": "Ночёвка (Мабит) в Муздалифе",
      "zh": "在穆兹达里法夜宿（Mabit）",
      "ja": "ムズダリファでの夜営（Mabit）",
      "ko": "무즈달리파에서의 숙박(Mabit)",
      "hi": "मुज़्दलिफ़ा में रात्रि विश्राम (Mabit)"
    },
    "body": [
      {
        "id": "Setelah matahari terbenam, jamaah bertolak dari Arafah menuju Muzdalifah dengan tenang tanpa berdesakan.",
        "en": "After sunset, the pilgrims depart from Arafah toward Muzdalifah calmly, without pushing or crowding.",
        "ar": "بعد غروب الشمس، يتحرك الحجاج من عرفة إلى مزدلفة بهدوء ودون تدافع.",
        "fr": "Après le coucher du soleil, les pèlerins partent d'Arafah vers Muzdalifah calmement, sans bousculade.",
        "de": "Nach dem Sonnenuntergang brechen die Pilger ruhig und ohne Gedränge von Arafah nach Muzdalifah auf.",
        "es": "Tras la puesta de sol, los peregrinos parten de Arafah hacia Muzdalifah con calma, sin aglomeraciones.",
        "ru": "После захода солнца паломники отправляются из Арафы в Муздалифу спокойно, без толчеи и давки.",
        "zh": "日落后，朝觐者从阿拉法特平静地出发前往穆兹达里法，不拥挤推搡。",
        "ja": "日没後、巡礼者たちは混雑することなく落ち着いてアラファからムズダリファへと出発する。",
        "ko": "일몰 후, 순례자들은 아라파에서 무즈달리파로 밀치거나 혼잡 없이 차분하게 출발한다.",
        "hi": "सूर्यास्त के बाद, हाजी शांतिपूर्वक और बिना भीड़-भाड़ के अरफ़ात से मुज़्दलिफ़ा की ओर रवाना होते हैं।"
      },
      {
        "id": "Di Muzdalifah, shalat Maghrib dan Isya dikerjakan dengan jamak takhir, lalu bermalam di sana hingga menjelang subuh.",
        "en": "In Muzdalifah, the Maghrib and Isha prayers are performed combined (Jama' Takhir), then the pilgrims spend the night there until just before Fajr.",
        "ar": "في مزدلفة، تُؤدَّى صلاتا المغرب والعشاء جمعًا تأخيرًا، ثم يبيت الحجاج هناك حتى قُبيل الفجر.",
        "fr": "À Muzdalifah, les prières du Maghrib et de l'Isha sont accomplies en regroupement différé (Jama' Takhir), puis les pèlerins y passent la nuit jusqu'à l'approche du Fajr.",
        "de": "In Muzdalifah werden die Maghrib- und Ischa-Gebete als Jama' Takhir (aufgeschobenes Verbundgebet) verrichtet, dann verbringen die Pilger die Nacht dort bis kurz vor dem Fajr.",
        "es": "En Muzdalifah, las oraciones del Maghrib e Isha se realizan combinadas en diferido (Jama' Takhir), luego los peregrinos pasan la noche allí hasta poco antes del Fajr.",
        "ru": "В Муздалифе молитвы Магриб и Иша совершаются объединённо с переносом (Джама' Тахир), после чего паломники проводят ночь там вплоть до времени, предшествующего Фаджру.",
        "zh": "在穆兹达里法，朝觐者将马格里布和伊沙礼拜以后合并（Jama' Takhir）方式礼拜，然后在那里过夜至黎明前。",
        "ja": "ムズダリファでは、マグリブとイシャーの礼拝をジャマー・タクヒール（後合わせ）で行い、その後ファジュル前まで夜を過ごす。",
        "ko": "무즈달리파에서는 마그립과 이샤 예배를 자마' 타크히르(합쳐서 늦게)로 드리고, 파즈르 직전까지 그곳에서 밤을 지낸다.",
        "hi": "मुज़्दलिफ़ा में, मग़रिब और इशा की नमाज़ें जमा' तखीर के रूप में एक साथ अदा की जाती हैं, फिर हाजी फज्र से पहले तक वहाँ रात गुज़ारते हैं।"
      },
      {
        "id": "Jamaah mengumpulkan kerikil untuk melempar jumrah (dapat pula diambil di Mina).",
        "en": "The pilgrims collect pebbles for throwing the Jamrah (they may also be gathered in Mina).",
        "ar": "يجمع الحجاج الحصى لرمي الجمرات، ويجوز أيضًا أخذها من منى.",
        "fr": "Les pèlerins ramassent des cailloux pour lapider les Jamrah (ils peuvent également être récoltés à Mina).",
        "de": "Die Pilger sammeln Kieselsteine für den Wurf der Jamrah (diese können auch in Mina aufgesammelt werden).",
        "es": "Los peregrinos recogen guijarros para arrojar las Jamrah (también pueden recogerse en Mina).",
        "ru": "Паломники собирают камешки для бросания в Джамру (их также можно подобрать в Мине).",
        "zh": "朝觐者捡拾小石子用于投掷石柱（Jamrah）（也可在米纳捡取）。",
        "ja": "巡礼者はジャムラ（Jamrah）に投石するための小石を集める（ミナで拾うことも可能）。",
        "ko": "순례자들은 자므라(Jamrah)를 던지기 위한 자갈을 줍는다 (미나에서 주워도 된다).",
        "hi": "हाजी जम्राह (Jamrah) को कंकरी मारने के लिए छोटे-छोटे पत्थर चुनते हैं (इन्हें मिना में भी उठाया जा सकता है)।"
      }
    ],
    "evidence": {
      "id": "HR. Muslim no. 1218. QS. Al-Baqarah: 198 («...berdzikirlah kepada Allah di Masy'aril Haram»).",
      "en": "HR. Muslim no. 1218. QS. Al-Baqarah: 198 (\"…remember Allah at the Masy'aril Haram\").",
      "ar": "رواه مسلم برقم ١٢١٨. سورة البقرة: ١٩٨ («...فَاذْكُرُوا اللَّهَ عِندَ الْمَشْعَرِ الْحَرَامِ»).",
      "fr": "HR. Muslim n° 1218. QS. Al-Baqarah : 198 (« …invoquez Allah au Masy'aril Haram »).",
      "de": "HR. Muslim Nr. 1218. QS. Al-Baqarah: 198 („…gedenkt Allahs am Masy'aril Haram\").",
      "es": "HR. Muslim n.º 1218. QS. Al-Baqarah: 198 («…recordad a Allah en el Masy'aril Haram»).",
      "ru": "Хадис имама Муслима № 1218. Коран, Аль-Бакара: 198 («…поминайте Аллаха у Маш'арил-Харам»).",
      "zh": "穆斯林圣训集第1218号。《古兰经》巴格拉章第198节（\"……在禁地圣址（Masy'aril Haram）处记念安拉\"）。",
      "ja": "フ・ムスリム第1218番。クルアーン・アル＝バカラ：198（「…マシュアリル・ハラームにてアッラーを念じよ」）。",
      "ko": "HR. 무슬림 1218번. QS. 알-바카라: 198 («…마쉬아릴 하람(Masy'aril Haram)에서 알라를 기억하라»).",
      "hi": "HR. मुस्लिम संख्या 1218. QS. अल-बक़रह: 198 («...मस्य'अरिल हराम (Masy'aril Haram) पर अल्लाह को याद करो»)।"
    }
  },
  {
    "id": "jamratul-aqabah",
    "day": "10",
    "status": "wajib",
    "loc": "jamarat",
    "arabic": "اللَّهُ أَكْبَرُ",
    "translit": "Allāhu akbar",
    "title": {
      "id": "Melempar Jamratul Aqabah",
      "en": "Throwing the Jamratul Aqabah",
      "ar": "رمي جمرة العقبة",
      "fr": "Lapidation de la Jamratul Aqabah",
      "de": "Steinigung der Jamratul Aqabah",
      "es": "Lapidación de la Jamratul Aqabah",
      "ru": "Бросание камней в Джамратул-Акабу",
      "zh": "投掷大石柱（Jamratul Aqabah）",
      "ja": "ジャムラトゥル・アカバ（Jamratul Aqabah）への投石",
      "ko": "잠라툴 아카바(Jamratul Aqabah) 투석",
      "hi": "जम्रतुल अक़बह (Jamratul Aqabah) को कंकरी मारना"
    },
    "body": [
      {
        "id": "Pada pagi 10 Dzulhijjah (hari Nahr), jamaah melempar Jamratul Aqabah (jumrah terbesar) dengan tujuh kerikil, bertakbir pada setiap lemparan.",
        "en": "On the morning of 10 Dhul-Hijjah (the Day of Nahr), pilgrims stone the Jamratul Aqabah (the largest Jamrah) with seven pebbles, pronouncing the takbir with each throw.",
        "ar": "في صباح العاشر من ذي الحجة (يوم النحر)، يرمي الحجاج جمرة العقبة الكبرى بسبع حصيات، مكبِّرين مع كل رمية.",
        "fr": "Le matin du 10 Dhul-Hijjah (jour du Nahr), les pèlerins lapident la Jamratul Aqabah (la plus grande Jamrah) avec sept cailloux, en prononçant le takbir à chaque lancer.",
        "de": "Am Morgen des 10. Dhul-Hijjah (Tag des Nahr) bewerfen die Pilger die Jamratul Aqabah (die größte Jamrah) mit sieben Kieselsteinen und sprechen bei jedem Wurf den Takbir aus.",
        "es": "En la mañana del 10 de Dhul-Hijjah (el Día del Nahr), los peregrinos lapidan la Jamratul Aqabah (la Jamrah más grande) con siete piedras, pronunciando el takbir en cada lanzamiento.",
        "ru": "Утром 10-го Зуль-Хиджи (в День Нахр) паломники бросают в Джамрат аль-Акабу (наибольший столб) семь камешков, произнося такбир при каждом броске.",
        "zh": "在12月10日（宰牲日）早晨，朝圣者向贾姆拉图·阿卡巴（最大的石柱）投掷七块石子，每次投掷时念诵\"真主至大\"。",
        "ja": "ズルヒッジャ月10日（ナフルの日）の朝、巡礼者はジャムラトゥル・アカバ（最大のジャムラ）に7つの小石を投げ、投げるたびにタクビールを唱えます。",
        "ko": "줄히자 10일(나흐르의 날) 아침, 순례자들은 잠라툴 아카바(가장 큰 잠라)에 돌 일곱 개를 던지며, 던질 때마다 타크비르를 외칩니다.",
        "hi": "ज़ुलहिज्जा की 10वीं तारीख (यौमे नहर) की सुबह, हाजी जमरतुल अकबा (सबसे बड़ी जमरह) पर सात कंकड़ मारते हैं और हर बार तकबीर कहते हैं।"
      },
      {
        "id": "Ini adalah amalan pertama di hari Nahr. Talbiyah dihentikan setelah lemparan pertama.",
        "en": "This is the first act on the Day of Nahr. The Talbiyah is stopped after the first throw.",
        "ar": "هذا هو أول عمل يُؤدَّى في يوم النحر. وتُقطع التلبية بعد الرمية الأولى.",
        "fr": "Il s'agit du premier acte accompli le Jour du Nahr. La Talbiyah est interrompue après le premier lancer.",
        "de": "Dies ist die erste Handlung am Tag des Nahr. Die Talbiyah wird nach dem ersten Wurf beendet.",
        "es": "Este es el primer acto del Día del Nahr. La Talbiyah se detiene después del primer lanzamiento.",
        "ru": "Это первое действие в День Нахр. Талбия прекращается после первого броска.",
        "zh": "这是宰牲日的第一项功课。在第一次投石之后，停止念诵塔勒比亚。",
        "ja": "これはナフルの日における最初の行為です。タルビヤは最初の投石の後に止められます。",
        "ko": "이것은 나흐르의 날에 행하는 첫 번째 의식입니다. 탈비야는 첫 번째 투석 후 중단됩니다.",
        "hi": "यह यौमे नहर का पहला अमल है। पहली कंकड़ फेंकने के बाद तलबियह पढ़ना बंद कर दिया जाता है।"
      }
    ],
    "dua": {
      "id": "Allah Maha Besar (diucapkan pada setiap lemparan kerikil).",
      "en": "Allah is the Greatest (said with every throw of a pebble).",
      "ar": "اللهُ أكبر (تُقال مع كل رمية حصاة).",
      "fr": "Allah est le Plus Grand (dit à chaque lancer de caillou).",
      "de": "Allah ist der Größte (wird bei jedem Wurf eines Kieselsteins gesagt).",
      "es": "Allah es el Más Grande (dicho con cada lanzamiento de una piedra).",
      "ru": "Аллах Велик (произносится при каждом броске камешка).",
      "zh": "真主至大（每次投掷石子时念诵）。",
      "ja": "アッラーは最も偉大です（小石を投げるたびに唱えます）。",
      "ko": "알라는 위대하십니다 (매번 돌을 던질 때마다 말합니다).",
      "hi": "अल्लाह सबसे बड़ा है (हर कंकड़ फेंकते वक्त कहा जाता है)।"
    },
    "evidence": {
      "id": "HR. Muslim no. 1218 (hadits Jabir).",
      "en": "HR. Muslim no. 1218 (Hadith of Jabir).",
      "ar": "رواه مسلم، رقم 1218 (حديث جابر رضي الله عنه).",
      "fr": "HR. Muslim n° 1218 (Hadith de Jabir).",
      "de": "HR. Muslim Nr. 1218 (Hadith von Jabir).",
      "es": "HR. Muslim n.º 1218 (Hadith de Jabir).",
      "ru": "Хадис Муслима № 1218 (хадис Джабира).",
      "zh": "穆斯林圣训集第1218号（贾比尔的圣训）。",
      "ja": "サヒーフ・ムスリム 第1218番（ジャービルのハディース）。",
      "ko": "HR. 무슬림 1218번 (자비르의 하디스).",
      "hi": "HR. मुस्लिम नंबर 1218 (जाबिर की हदीस)।"
    }
  },
  {
    "id": "hadyu",
    "day": "10",
    "status": "wajib",
    "loc": "mina",
    "arabic": "",
    "translit": "",
    "title": {
      "id": "Menyembelih Hadyu (Kurban Haji)",
      "en": "Slaughtering the Hadyu (Hajj Sacrifice)",
      "ar": "ذبح الهَدْي (أضحية الحج)",
      "fr": "Abattage du Hadyu (sacrifice du Hajj)",
      "de": "Schlachten des Hadyu (Hajj-Opfer)",
      "es": "Sacrificio del Hadyu (ofrenda del Hajj)",
      "ru": "Заклание хадью (жертвоприношение Хаджа)",
      "zh": "宰献哈迪（朝觐献牲）",
      "ja": "ハドユの屠殺（ハッジの供犠）",
      "ko": "하디유 도축 (하즈 희생 제물)",
      "hi": "हद्यु की कुर्बानी (हज का जानवर ज़बह करना)"
    },
    "body": [
      {
        "id": "Bagi haji Tamattu' dan Qiran, wajib menyembelih hadyu sebagai syukur atas nikmat menggabungkan umrah dan haji.",
        "en": "For Hajj Tamattu' and Qiran, it is obligatory to slaughter a Hadyu as gratitude for the blessing of combining Umrah and Hajj.",
        "ar": "يجب على حاج التمتع والقِران ذبح الهَدْي شكراً لله على نعمة الجمع بين العمرة والحج.",
        "fr": "Pour le Hajj Tamattu' et Qiran, il est obligatoire d'immoler un Hadyu en remerciement pour la grâce d'avoir combiné la Umrah et le Hajj.",
        "de": "Für Hajj Tamattu' und Qiran ist es Pflicht, ein Hadyu zu schlachten, als Dankbarkeit für die Gunst, Umrah und Hajj zu verbinden.",
        "es": "Para el Hajj Tamattu' y Qiran, es obligatorio sacrificar un Hadyu como agradecimiento por la bendición de combinar la Umrah y el Hajj.",
        "ru": "Для Хаджа Таматту' и Киран обязательно заколоть хадью в знак благодарности Аллаху за возможность совместить Умру и Хадж.",
        "zh": "对于享受朝（塔玛图）和合并朝（基兰）的朝圣者，必须宰献哈迪，以感谢将乌姆拉与哈吉合并的恩典。",
        "ja": "ハッジ・タマットゥとキランの場合、ウムラとハッジを合わせる恩恵への感謝として、ハドユを屠殺することが義務となります。",
        "ko": "하즈 타맛투'와 키란의 경우, 우므라와 하즈를 합친 은혜에 대한 감사로 하디유를 도축하는 것이 의무입니다.",
        "hi": "हज तमत्तु' और किरान के लिए, उमरह और हज को एक साथ अदा करने की नेमत पर शुक्रगुज़ारी के तौर पर हद्यु ज़बह करना वाजिब है।"
      },
      {
        "id": "Bila tidak mampu, diganti dengan puasa tiga hari pada masa haji dan tujuh hari setelah pulang (total sepuluh hari).",
        "en": "If unable, it is replaced by fasting three days during Hajj and seven days after returning home (a total of ten days).",
        "ar": "فإن لم يستطع، فعليه صيام ثلاثة أيام في الحج وسبعة أيام بعد العودة (عشرة أيام في المجموع).",
        "fr": "Si l'on n'en est pas capable, on jeûne trois jours durant le Hajj et sept jours après le retour (soit dix jours au total).",
        "de": "Wer dazu nicht in der Lage ist, fastet stattdessen drei Tage während des Hajj und sieben Tage nach der Rückkehr (insgesamt zehn Tage).",
        "es": "Si no se puede, se ayuna tres días durante el Hajj y siete días tras regresar a casa (diez días en total).",
        "ru": "Если нет возможности, заменяется постом три дня во время Хаджа и семь дней после возвращения домой (итого десять дней).",
        "zh": "若无力承担，则以封斋代替——在朝觐期间斋戒三天，回家后再斋戒七天（共计十天）。",
        "ja": "能力がない場合は、ハッジ中に3日間、帰宅後に7日間の断食（合計10日間）に代替される。",
        "ko": "감당하지 못할 경우, 하즈 기간 중 3일, 귀국 후 7일(총 10일)의 단식으로 대체된다.",
        "hi": "यदि असमर्थ हों, तो हज के दौरान तीन दिन और घर लौटने के बाद सात दिन (कुल दस दिन) का रोज़ा रखा जाएगा।"
      },
      {
        "id": "Penyembelihan pada masa kini umumnya dikelola lembaga resmi di Makkah pada hari Nahr dan hari-hari Tasyrik.",
        "en": "Slaughtering nowadays is generally managed by official institutions in Makkah on the day of Nahr and the days of Tasyrik.",
        "ar": "تُدار عمليات الذبح في الوقت الحاضر عمومًا من قِبل مؤسسات رسمية في مكة المكرمة في يوم النحر وأيام التشريق.",
        "fr": "L'abattage de nos jours est généralement géré par des institutions officielles à La Mecque le jour du Nahr et les jours de Tasyrik.",
        "de": "Das Schlachten wird heutzutage in der Regel von offiziellen Einrichtungen in Makkah am Tag des Nahr und an den Tasyrik-Tagen organisiert.",
        "es": "El sacrificio en la actualidad es gestionado generalmente por instituciones oficiales en La Meca el día del Nahr y los días de Tasyrik.",
        "ru": "В наши дни заклание, как правило, осуществляется официальными учреждениями в Макке в день Нахр и в дни Ташрик.",
        "zh": "如今，宰牲通常由麦加官方机构统一管理，在宰牲日（Nahr）及塔什里克日（Tasyrik）进行。",
        "ja": "現代における屠殺は、一般的にマッカの公式機関によってナフルの日とタシュリークの日に管理・執行されている。",
        "ko": "오늘날의 도축은 일반적으로 마카의 공식 기관이 나흐르(Nahr) 당일과 타쉬리크(Tasyrik) 기간에 관리한다.",
        "hi": "आजकल कुर्बानी (ज़बह) का कार्य सामान्यतः मक्का की आधिकारिक संस्थाओं द्वारा नहर के दिन और तश्रीक के दिनों में संचालित किया जाता है।"
      }
    ],
    "evidence": {
      "id": "QS. Al-Baqarah: 196 («...maka (wajib menyembelih) hadyu yang mudah didapat...»).",
      "en": "QS. Al-Baqarah: 196 (\"…then (it is obligatory to offer) a Hadyu that is easy to obtain…\").",
      "ar": "سورة البقرة: 196 («...فَمَا اسْتَيْسَرَ مِنَ الْهَدْيِ...»).",
      "fr": "QS. Al-Baqarah : 196 (« …alors (il est obligatoire d'offrir) le Hadyu le plus facile à obtenir… »).",
      "de": "QS. Al-Baqarah: 196 („…dann (ist es Pflicht, ein) Hadyu darzubringen, das leicht zu beschaffen ist…\").",
      "es": "QS. Al-Baqarah: 196 («…entonces (es obligatorio ofrecer) el Hadyu que sea más fácil de obtener…»).",
      "ru": "Коран, сура Аль-Бакара: 196 («…то (обязательно принести в жертву) Хадью, которое легко раздобыть…»).",
      "zh": "《古兰经》黄牛章（2）：196（\"……则（须献）力所能及的牲畜（Hadyu）……\"）。",
      "ja": "クルアーン、アル＝バカラ章：196（「…（やむを得ない場合は）入手しやすいハドユを（捧げることが義務となる）…」）。",
      "ko": "꾸란 알-바카라 2장: 196 (\"…그러면 구하기 쉬운 하드유(Hadyu)를 (바치는 것이 의무이니)…\").",
      "hi": "सूरः अल-बक़रह: 196 («…तो (वाजिब है) जो हद्यु (Hadyu) आसानी से उपलब्ध हो…»)।"
    }
  },
  {
    "id": "tahallul-awal",
    "day": "10",
    "status": "wajib",
    "loc": "mina",
    "arabic": "",
    "translit": "",
    "title": {
      "id": "Tahallul Awal (Mencukur / Memotong Rambut)",
      "en": "Tahallul Awal (Shaving / Trimming the Hair)",
      "ar": "التحلل الأول (الحلق أو التقصير)",
      "fr": "Tahallul Awal (Rasage / Coupe des cheveux)",
      "de": "Tahallul Awal (Rasieren / Kürzen der Haare)",
      "es": "Tahallul Awal (Rasurado / Recorte del cabello)",
      "ru": "Тахаллюль Авваль (Бритьё / Укорачивание волос)",
      "zh": "初次解禁（Tahallul Awal）——剃发或剪发",
      "ja": "タハッルル・アウワル（Tahallul Awal）——剃髪または散髪",
      "ko": "타할룰 아왈(Tahallul Awal) — 삭발 또는 머리카락 다듬기",
      "hi": "तहल्लुल अव्वल (Tahallul Awal) — बाल मुंडवाना / छोटा करवाना"
    },
    "body": [
      {
        "id": "Setelah melempar dan menyembelih, jamaah mencukur (halq) atau memendekkan (taqshir) rambut. Mencukur gundul lebih utama bagi laki-laki.",
        "en": "After stoning and slaughtering, pilgrims shave (halq) or shorten (taqshir) their hair. Shaving the head completely is more virtuous for men.",
        "ar": "بعد الرمي والذبح، يقوم الحاج بحلق رأسه (حلق) أو تقصير شعره (تقصير). والحلق أفضل للرجال.",
        "fr": "Après le jet des pierres et l'abattage, les pèlerins rasent (halq) ou raccourcissent (taqshir) leurs cheveux. Le rasage complet est plus méritoire pour les hommes.",
        "de": "Nach dem Steinigen und Schlachten rasieren (Halq) oder kürzen (Taqshir) die Pilger ihr Haar. Das vollständige Rasieren ist für Männer vorzuziehen.",
        "es": "Tras el lanzamiento de piedras y el sacrificio, los peregrinos se rapan (halq) o se recortan (taqshir) el cabello. El afeitado completo es más virtuoso para los hombres.",
        "ru": "После бросания камней и заклания паломники бреют (халк) или укорачивают (такшир) волосы. Полное бритьё головы предпочтительнее для мужчин.",
        "zh": "投石和宰牲之后，朝觐者剃头（Halq）或剪短头发（Taqshir）。对男性而言，完全剃光头发更为优先。",
        "ja": "投石と屠殺の後、巡礼者は頭を剃る（ハルク）か、髪を短くする（タクシール）。男性にとって完全な剃髪がより優れている。",
        "ko": "투석과 도축 이후, 순례자들은 머리를 밀거나(halq) 머리카락을 짧게 자른다(taqshir). 남성에게는 완전히 삭발하는 것이 더 권장된다.",
        "hi": "कंकरी मारने और कुर्बानी के बाद, हाजी सिर मुंडवाते (हल्क़) या बाल छोटे करवाते (तक़्सीर) हैं। पुरुषों के लिए पूरा सिर मुंडवाना अधिक उत्तम है।"
      },
      {
        "id": "Dengan tahallul awal ini, sebagian besar larangan ihram kembali dibolehkan, kecuali berhubungan suami-istri hingga tahallul sempurna.",
        "en": "With this Tahallul Awal, most of the Ihram prohibitions become permissible again, except marital relations until the complete Tahallul is performed.",
        "ar": "بهذا التحلل الأول، تحل معظم محظورات الإحرام، ما عدا الجماع، حتى يتم التحلل الثاني (التحلل الأكمل).",
        "fr": "Avec ce Tahallul Awal, la plupart des interdictions de l'Ihram redeviennent permises, sauf les relations conjugales, jusqu'au Tahallul complet.",
        "de": "Mit diesem Tahallul Awal werden die meisten Ihram-Verbote wieder erlaubt, mit Ausnahme des ehelichen Verkehrs, bis das vollständige Tahallul vollzogen ist.",
        "es": "Con este Tahallul Awal, la mayoría de las prohibiciones del Ihram vuelven a ser lícitas, salvo las relaciones conyugales, hasta que se complete el Tahallul definitivo.",
        "ru": "С этим Тахаллюль Авваль большинство запретов Ихрама снимается, за исключением супружеских отношений, которые остаются под запретом до полного Тахаллюля.",
        "zh": "完成初次解禁（Tahallul Awal）后，大部分伊赫拉姆（Ihram）的禁忌重新被允许，但夫妻同房仍须等到完全解禁（Tahallul Sempurna）之后方可。",
        "ja": "このタハッルル・アウワルにより、イフラームの禁止事項のほとんどが再び許可されるが、完全なタハッルルが行われるまで夫婦関係は引き続き禁じられる。",
        "ko": "이 타할룰 아왈(Tahallul Awal)을 통해 이흐람의 대부분의 금지 사항이 다시 허용되지만, 완전한 타할룰이 이루어질 때까지 부부관계는 여전히 금지된다.",
        "hi": "इस तहल्लुल अव्वल के साथ, इह्राम की अधिकांश पाबंदियाँ पुनः जायज़ हो जाती हैं, सिवाय वैवाहिक संबंध के, जो तहल्लुल-ए-कामिल (पूर्ण तहल्लुल) तक वर्जित रहते हैं।"
      }
    ],
    "evidence": {
      "id": "QS. Al-Fath: 27. Nabi ﷺ mendoakan tiga kali kebaikan bagi yang mencukur gundul (HR. Bukhari no. 1727 & Muslim no. 1301).",
      "en": "QS. Al-Fath: 27. The Prophet ﷺ supplicated three times for goodness upon those who shave their heads completely (HR. Bukhari no. 1727 & Muslim no. 1301).",
      "ar": "سورة الفتح: 27. دعا النبي ﷺ ثلاث مرات بالخير لمن حلق رأسه كاملاً (رواه البخاري رقم 1727 ومسلم رقم 1301).",
      "fr": "QS. Al-Fath : 27. Le Prophète ﷺ a invoqué trois fois la bénédiction pour ceux qui se rasent entièrement la tête (HR. Bukhari n° 1727 & Muslim n° 1301).",
      "de": "QS. Al-Fath: 27. Der Prophet ﷺ bat dreimal um Segen für diejenigen, die ihr Haupt vollständig rasieren (HR. Bukhari Nr. 1727 & Muslim Nr. 1301).",
      "es": "QS. Al-Fath: 27. El Profeta ﷺ suplicó tres veces el bien para quienes se afeitaban la cabeza por completo (HR. Bukhari n.° 1727 & Muslim n.° 1301).",
      "ru": "QС. Аль-Фатх: 27. Пророк ﷺ трижды обратился с мольбой о благе для тех, кто полностью обривает голову (Бухари № 1727 и Муслим № 1301).",
      "zh": "《古兰经》胜利章第27节。先知ﷺ三次祈求真主赐福于剃头者（布哈里圣训第1727条及穆斯林圣训第1301条）。",
      "ja": "クルアーン「征服章」27節。預言者ﷺは頭を剃り落とした者のために三度善を祈られた（ブハーリー第1727番・ムスリム第1301番）。",
      "ko": "꾸란 알-파트흐 27절. 예언자ﷺ께서는 머리를 완전히 민 자들을 위해 세 번 복을 빌어 주셨다(부카리 제1727번 & 무슬림 제1301번).",
      "hi": "क़ुरआन, सूरह अल-फ़त्ह: 27। नबी ﷺ ने सिर मुंडवाने वालों के लिए तीन बार भलाई की दुआ फ़रमाई (बुख़ारी क्र. 1727 और मुस्लिम क्र. 1301)।"
    }
  },
  {
    "id": "tawaf-ifadah",
    "day": "10",
    "status": "rukun",
    "loc": "makkah",
    "arabic": "",
    "translit": "",
    "title": {
      "id": "Tawaf Ifadah & Sa'i",
      "en": "Tawaf Ifadah & Sa'i",
      "ar": "طواف الإفاضة والسعي",
      "fr": "Tawaf Ifadah & Sa'i",
      "de": "Tawaf Ifadah & Sa'i",
      "es": "Tawaf Ifadah & Sa'i",
      "ru": "Таваф Ифада и Са'й",
      "zh": "绕行告别（塔瓦夫·伊法达）与奔走（萨伊）",
      "ja": "タワーフ・イファーダとサイ",
      "ko": "타와프 이파다 & 사이",
      "hi": "तवाफ़ इफ़ाज़ा और सई"
    },
    "body": [
      {
        "id": "Jamaah menuju Masjidil Haram untuk menunaikan Tawaf Ifadah — rukun haji — mengelilingi Ka'bah tujuh putaran.",
        "en": "The pilgrims proceed to Masjidil Haram to perform Tawaf Ifadah — a pillar of Hajj — circumambulating the Ka'bah seven times.",
        "ar": "يتوجه الحجاج إلى المسجد الحرام لأداء طواف الإفاضة — ركن من أركان الحج — بالطواف حول الكعبة سبعة أشواط.",
        "fr": "Les pèlerins se dirigent vers la Masjidil Haram pour accomplir le Tawaf Ifadah — pilier du Hajj — en faisant sept tours autour de la Ka'bah.",
        "de": "Die Pilger begeben sich zur Masjidil Haram, um den Tawaf Ifadah — eine Säule des Hajj — zu verrichten, indem sie die Ka'bah sieben Mal umrunden.",
        "es": "Los peregrinos se dirigen a la Masjidil Haram para realizar el Tawaf Ifadah — un pilar del Hajj — circunvalando la Ka'bah siete veces.",
        "ru": "Паломники направляются в Масджид аль-Харам для совершения Таваф Ифада — рукна хаджа — обходя Каабу семь раз.",
        "zh": "朝觐者前往禁寺（麦斯吉德·哈拉姆），履行塔瓦夫·伊法达——朝觐的柱功之一——绕克尔白七圈。",
        "ja": "巡礼者たちはマスジドゥル・ハラームへ向かい、ハッジの柱であるタワーフ・イファーダとしてカアバを七周する。",
        "ko": "순례자들은 하지의 핵심 기둥인 타와프 이파다를 수행하기 위해 마스지둘 하람으로 향하여 카으바를 일곱 바퀴 돈다.",
        "hi": "हाजी, हज के रुक्न — तवाफ़ इफ़ाज़ा — अदा करने के लिए मस्जिदुल हराम जाते हैं और काबह के सात चक्कर लगाते हैं।"
      },
      {
        "id": "Bagi haji Tamattu', dilanjutkan Sa'i antara Shafa dan Marwah tujuh kali.",
        "en": "For Hajj Tamattu', this is followed by Sa'i between Shafa and Marwah seven times.",
        "ar": "بالنسبة لحج التمتع، يُتبع ذلك بالسعي بين الصفا والمروة سبعة أشواط.",
        "fr": "Pour le Hajj Tamattu', cela est suivi du Sa'i entre Shafa et Marwah sept fois.",
        "de": "Beim Hajj Tamattu' folgt darauf der Sa'i zwischen Shafa und Marwah siebenmal.",
        "es": "Para el Hajj Tamattu', esto va seguido del Sa'i entre Shafa y Marwah siete veces.",
        "ru": "Для хаджа Таматту' за этим следует Са'й между Сафой и Марвой семь раз.",
        "zh": "对于享受朝（哈吉·塔玛图），随后在萨法与麦尔卧之间往返奔走（萨伊）七次。",
        "ja": "ハッジ・タマットゥの場合は、続けてサファーとマルワーの間をサイとして七往復する。",
        "ko": "하지 타맛투'의 경우, 이어서 사파와 마르와 사이를 일곱 번 왕복하는 사이를 행한다.",
        "hi": "हज तमत्तु' के लिए, इसके बाद सफ़ा और मरवा के बीच सात बार सई की जाती है।"
      },
      {
        "id": "Setelah Tawaf Ifadah dan Sa'i, tahallul menjadi sempurna (tahallul tsani) dan seluruh larangan ihram gugur.",
        "en": "After Tawaf Ifadah and Sa'i, the Tahallul becomes complete (Tahallul Tsani) and all Ihram prohibitions are lifted.",
        "ar": "بعد طواف الإفاضة والسعي، يكتمل التحلل (التحلل الثاني) وترتفع جميع محظورات الإحرام.",
        "fr": "Après le Tawaf Ifadah et le Sa'i, le Tahallul devient complet (Tahallul Tsani) et toutes les interdictions de l'Ihram sont levées.",
        "de": "Nach dem Tawaf Ifadah und dem Sa'i ist der Tahallul vollständig (Tahallul Tsani) und alle Ihram-Verbote sind aufgehoben.",
        "es": "Tras el Tawaf Ifadah y el Sa'i, el Tahallul se completa (Tahallul Tsani) y todas las prohibiciones del Ihram quedan levantadas.",
        "ru": "После Таваф Ифада и Са'я Тахаллюль становится полным (Тахаллюль Цани) и все запреты Ихрама снимаются.",
        "zh": "完成塔瓦夫·伊法达和萨伊后，解禁（脱离戒戒状态）彻底完成（第二次解禁），所有戒衣禁令全部解除。",
        "ja": "タワーフ・イファーダとサイの後、タハッルルが完成し（タハッルル・サーニー）、イフラームのすべての禁止事項が解除される。",
        "ko": "타와프 이파다와 사이를 마친 후, 타할룰이 완성되어(타할룰 사니) 이흐람의 모든 금지 사항이 해제된다.",
        "hi": "तवाफ़ इफ़ाज़ा और सई के बाद, तहल्लुल पूर्ण हो जाता है (तहल्लुल सानी) और इहराम की सभी पाबंदियाँ समाप्त हो जाती हैं।"
      }
    ],
    "evidence": {
      "id": "QS. Al-Hajj: 29 («...dan hendaklah mereka melakukan tawaf di Baitullah yang tua itu»). HR. Muslim no. 1218.",
      "en": "QS. Al-Hajj: 29 («...and let them perform Tawaf around the ancient House»). HR. Muslim no. 1218.",
      "ar": "سورة الحج: 29 («...وَلْيَطَّوَّفُوا بِالْبَيْتِ الْعَتِيقِ»). رواه مسلم رقم 1218.",
      "fr": "QS. Al-Hajj : 29 («...et qu'ils accomplissent le Tawaf autour de la Maison antique»). HR. Muslim n° 1218.",
      "de": "QS. Al-Hajj: 29 («...und sie sollen Tawaf um das altehrwürdige Haus vollziehen»). HR. Muslim Nr. 1218.",
      "es": "QS. Al-Hajj: 29 («...y que realicen el Tawaf alrededor de la Casa Antigua»). HR. Muslim n.° 1218.",
      "ru": "КС. Аль-Хадж: 29 («...и пусть они совершат Таваф вокруг древнего Дома»). Муслим № 1218.",
      "zh": "《古兰经》朝觐章第29节（\"……并应绕古老的天房行塔瓦夫\"）。穆斯林圣训第1218条。",
      "ja": "クルアーン「巡礼章」29節（「…そして彼らは古き家（カアバ）の周りをタワーフせよ」）。ムスリム第1218番。",
      "ko": "꾸란 알-하즈 29절 («...그리고 그들은 오래된 집(카으바) 주위를 타와프하라»). 무슬림 제1218번.",
      "hi": "क़ुरआन, सूरह अल-हज्ज: 29 («...और वे पुराने घर (काबह) का तवाफ़ करें»)। मुस्लिम क्र. 1218।"
    }
  },
  {
    "id": "mabit-mina",
    "day": "tasyrik",
    "status": "wajib",
    "loc": "mina",
    "arabic": "",
    "translit": "",
    "title": {
      "id": "Mabit di Mina (Hari Tasyrik)",
      "en": "Mabit in Mina (Tasyrik Days)",
      "ar": "المبيت في منى (أيام التشريق)",
      "fr": "Mabit à Mina (Jours de Tachrik)",
      "de": "Mabit in Mina (Taschriq-Tage)",
      "es": "Mabit en Mina (Días de Tashrik)",
      "ru": "Мабит в Мине (Дни Ташрик)",
      "zh": "在米纳过夜（塔什里克日）",
      "ja": "ミナーでのマビット（タシュリークの日々）",
      "ko": "미나에서의 마비트 (타쉬리크의 날들)",
      "hi": "मिना में मबीत (तशरीक के दिन)"
    },
    "body": [
      {
        "id": "Pada malam-malam 11, 12, dan 13 Dzulhijjah, jamaah bermalam (mabit) di Mina.",
        "en": "On the nights of the 11th, 12th, and 13th of Dzulhijjah, pilgrims spend the night (mabit) in Mina.",
        "ar": "في ليالي الحادي عشر والثاني عشر والثالث عشر من ذي الحجة، يبيت الحجاج في منى.",
        "fr": "Durant les nuits des 11, 12 et 13 Dhou al-Hijja, les pèlerins passent la nuit (mabit) à Mina.",
        "de": "In den Nächten des 11., 12. und 13. Dhul Hijja verbringen die Pilger die Nacht (Mabit) in Mina.",
        "es": "En las noches del 11, 12 y 13 de Dzulhijjah, los peregrinos pernoctan (mabit) en Mina.",
        "ru": "В ночи 11-го, 12-го и 13-го числа месяца Зуль-Хиджа паломники проводят ночь (мабит) в Мине.",
        "zh": "在杜尔·黑哲月的第11、12、13夜，朝觐者在米纳过夜（马比特）。",
        "ja": "ズルヒッジャ月の11日、12日、13日の夜、巡礼者はミナーで夜を過ごします（マビット）。",
        "ko": "줄히자월 11일, 12일, 13일 밤에 순례자들은 미나에서 밤을 보냅니다 (마비트).",
        "hi": "ज़ुल्हिज्जा की 11वीं, 12वीं और 13वीं रात को, हाजी मिना में रात बिताते हैं (मबीत)।"
      },
      {
        "id": "Hari-hari Tasyrik adalah hari makan, minum, dan memperbanyak dzikir kepada Allah — perbanyak takbir.",
        "en": "The Tasyrik days are days of eating, drinking, and abundantly remembering Allah — increase in takbir.",
        "ar": "أيام التشريق هي أيام أكل وشرب وإكثار من ذكر الله — فأكثروا من التكبير.",
        "fr": "Les jours de Tachrik sont des jours pour manger, boire et abonder dans le dhikr d'Allah — multipliez les takbir.",
        "de": "Die Taschriq-Tage sind Tage des Essens, Trinkens und des reichlichen Gedenkens Allahs — vermehrt den Takbir.",
        "es": "Los días de Tashrik son días de comer, beber y abundar en el dhikr de Allah — multiplica el takbir.",
        "ru": "Дни Ташрик — это дни еды, питья и обильного поминания Аллаха — увеличивайте такбир.",
        "zh": "塔什里克日是饮食和大量记念真主的日子——多多诵读塔克比尔。",
        "ja": "タシュリークの日々は飲食を楽しみ、アッラーを多くズィクルする日々です — タクビールを増やしましょう。",
        "ko": "타쉬리크의 날들은 먹고 마시며 알라를 많이 기억하는 날들입니다 — 타크비르를 많이 하십시오.",
        "hi": "तशरीक के दिन खाने, पीने और अल्लाह का ज़िक्र अधिक करने के दिन हैं — तकबीर अधिक पढ़ें।"
      }
    ],
    "evidence": {
      "id": "QS. Al-Baqarah: 203. «Hari Tasyrik adalah hari makan, minum, dan dzikir kepada Allah» (HR. Muslim no. 1141).",
      "en": "QS. Al-Baqarah: 203. «The Tasyrik days are days of eating, drinking, and remembrance of Allah» (HR. Muslim no. 1141).",
      "ar": "سورة البقرة: 203. «أيام التشريق هي أيام أكل وشرب وذكر الله» (رواه مسلم برقم 1141).",
      "fr": "Sourate Al-Baqarah : 203. «Les jours de Tachrik sont des jours de manger, de boire et de dhikr d'Allah» (HR. Muslim n° 1141).",
      "de": "Sure Al-Baqarah: 203. «Die Taschriq-Tage sind Tage des Essens, Trinkens und des Gedenkens Allahs» (HR. Muslim Nr. 1141).",
      "es": "Sura Al-Baqarah: 203. «Los días de Tashrik son días de comer, beber y dhikr de Allah» (HR. Muslim n.° 1141).",
      "ru": "Сура Аль-Бакара: 203. «Дни Ташрик — это дни еды, питья и поминания Аллаха» (Муслим № 1141).",
      "zh": "《古兰经》巴格拉章：203节。「塔什里克日是饮食和记念真主的日子」（穆斯林圣训集第1141条）。",
      "ja": "スーラ・アル＝バカラ：203節。「タシュリークの日々は飲食とアッラーのズィクルの日々である」（ムスリム集 第1141番）。",
      "ko": "수라 알-바카라: 203절. «타쉬리크의 날들은 먹고 마시며 알라를 기억하는 날들이다» (HR. 무슬림 제1141호).",
      "hi": "सूरह अल-बकरह: 203. «तशरीक के दिन खाने, पीने और अल्लाह के ज़िक्र के दिन हैं» (HR. मुस्लिम नं. 1141)।"
    }
  },
  {
    "id": "jamarat-tiga",
    "day": "tasyrik",
    "status": "wajib",
    "loc": "jamarat",
    "arabic": "",
    "translit": "",
    "title": {
      "id": "Melempar Tiga Jumrah (11–13)",
      "en": "Throwing the Three Jamarat (11–13)",
      "ar": "رمي الجمرات الثلاث (11–13)",
      "fr": "Lapidation des trois Jamarat (11–13)",
      "de": "Steinigung der drei Dschamarat (11–13)",
      "es": "Lanzamiento de las tres Jamarat (11–13)",
      "ru": "Бросание камней в три Джамарат (11–13)",
      "zh": "投掷三座贾马拉特（11–13日）",
      "ja": "三つのジャマラートへの投石（11〜13日）",
      "ko": "세 개의 자마라트 투석 (11–13일)",
      "hi": "तीन जमरात पर कंकड़ फेंकना (11–13)"
    },
    "body": [
      {
        "id": "Setiap hari Tasyrik, jamaah melempar tiga jumrah secara berurutan: Ula, Wustha, lalu Aqabah — masing-masing tujuh kerikil.",
        "en": "Each Tasyrik day, pilgrims stone the three Jamarat in order: Ula, Wustha, then Aqabah — seven pebbles each.",
        "ar": "في كل يوم من أيام التشريق، يرمي الحجاج الجمرات الثلاث بالترتيب: الأولى، ثم الوسطى، ثم العقبة — سبع حصيات لكل منها.",
        "fr": "Chaque jour de Tachrik, les pèlerins lapident les trois Jamarat dans l'ordre : Ula, Wustha, puis Aqabah — sept cailloux chacune.",
        "de": "An jedem Taschriq-Tag bewerfen die Pilger die drei Dschamarat der Reihe nach: Ula, Wustha und dann Aqabah — jeweils sieben Kieselsteine.",
        "es": "Cada día de Tashrik, los peregrinos apedrean las tres Jamarat en orden: Ula, Wustha y luego Aqabah — siete piedrecillas cada una.",
        "ru": "В каждый из дней Ташрик паломники бросают камни в три Джамарат по порядку: Уля, Вуста, затем Акаба — по семь камешков в каждую.",
        "zh": "每个塔什里克日，朝觐者依次向三座贾马拉特投掷石块：小贾马拉（乌拉）、中贾马拉（乌斯塔），再到大贾马拉（阿卡巴）——每座各七颗小石子。",
        "ja": "タシュリークの各日、巡礼者は順番に三つのジャマラートに投石します：ウーラー、ウスター、そしてアカバ — それぞれ七つの小石を投げます。",
        "ko": "타쉬리크 매일, 순례자들은 세 개의 자마라트에 순서대로 투석합니다: 울라, 우스타, 그다음 아카바 — 각각 일곱 개의 조약돌.",
        "hi": "प्रत्येक तशरीक के दिन, हाजी क्रमशः तीन जमरात पर कंकड़ फेंकते हैं: उला, वुस्ता, फिर अकबा — प्रत्येक पर सात कंकड़।"
      },
      {
        "id": "Waktunya setelah matahari tergelincir (Zuhur). Disunnahkan berdoa panjang menghadap kiblat setelah jumrah Ula dan Wustha.",
        "en": "The time is after the sun has passed its zenith (Zuhr). It is recommended (Sunnah) to make a lengthy supplication facing the Qiblah after the Ula and Wustha Jamarat.",
        "ar": "وقتُه بعد زوال الشمس (الظهر). ويُسنُّ الإطالةُ في الدعاء مستقبلاً القبلةَ بعد رمي الجمرة الصغرى والوسطى.",
        "fr": "Le moment est après le déclin du soleil (Dhouhr). Il est recommandé (Sunnah) de faire une longue supplication en direction de la Qiblah après les Jamarat Ula et Wustha.",
        "de": "Die Zeit beginnt nach dem Sonnenhöchststand (Zuhr). Es ist empfohlen (Sunnah), nach den Jamarat Ula und Wustha ein langes Bittgebet in Richtung der Qiblah zu sprechen.",
        "es": "El tiempo es después de que el sol ha pasado su cénit (Zuhr). Es recomendable (Sunnah) realizar una larga súplica mirando hacia la Qiblah después de los Jamarat Ula y Wustha.",
        "ru": "Время наступает после того, как солнце миновало зенит (Зухр). Желательно (Сунна) совершить продолжительное ду'а, обратившись лицом к Кибле, после бросания Джамрат Уля и Вуста.",
        "zh": "时间在太阳过顶（晌礼）之后。在投掷初石柱（Ula）和中石柱（Wustha）之后，面朝朝向（Qiblah）作较长的祈祷是圣行（Sunnah）。",
        "ja": "時刻は太陽が中天を過ぎた後（ズフル）です。ジャマラート・ウラーとジャマラート・ウスタの後、キブラに向かって長い祈り（ドゥアー）を行うことがスンナです。",
        "ko": "시간은 태양이 정점을 지난 후(주흐르)입니다. 자마라트 울라와 자마라트 우스타를 던진 후 끼블라 방향을 향해 긴 두아를 드리는 것이 순나입니다.",
        "hi": "समय सूर्य के ढलने (ज़ुहर) के बाद का है। जमरात उला और वुस्ता के बाद क़िब्ला की ओर मुँह करके लंबी दुआ करना सुन्नत है।"
      },
      {
        "id": "Nafar Awal: boleh meninggalkan Mina pada 12 Dzulhijjah sebelum maghrib. Nafar Tsani: menetap hingga 13 dan melempar kembali (lebih utama).",
        "en": "Nafar Awal: one may leave Mina on the 12th of Dhul-Hijjah before Maghrib. Nafar Tsani: remaining until the 13th and casting stones again (this is more virtuous).",
        "ar": "النفر الأول: يجوز مغادرة منى في اليوم الثاني عشر من ذي الحجة قبل المغرب. النفر الثاني: المكث حتى اليوم الثالث عشر والرمي مرةً أخرى (وهو أفضل).",
        "fr": "Nafar Awal : il est permis de quitter Mina le 12 Dhul-Hijjah avant le Maghrib. Nafar Tsani : rester jusqu'au 13 et lancer à nouveau les pierres (ce qui est plus méritoire).",
        "de": "Nafar Awal: Es ist erlaubt, Mina am 12. Dhul-Hijjah vor dem Maghrib zu verlassen. Nafar Tsani: bis zum 13. zu verbleiben und erneut zu steinigen (dies ist vorzuziehen).",
        "es": "Nafar Awal: está permitido abandonar Mina el 12 de Dhul-Hijjah antes del Maghrib. Nafar Tsani: permanecer hasta el día 13 y lanzar las piedras de nuevo (esto es más meritorio).",
        "ru": "Нафар Авваль: разрешается покинуть Мину 12-го зуль-хиджжа до Магриба. Нафар Сани: оставаться до 13-го и снова совершить бросание (это предпочтительнее).",
        "zh": "纳法尔·阿瓦勒（Nafar Awal）：允许在十二月（朝觐月）十二日马格里布前离开米纳。纳法尔·萨尼（Nafar Tsani）：留至十三日并再次投石（此更为优越）。",
        "ja": "ナファル・アウワル：12日のズルヒッジャ月のマグリブ前にミナーを出発することが認められます。ナファル・サーニー：13日まで留まり再び投石すること（こちらがより優れています）。",
        "ko": "나파르 아왈: 12 줄히자 마그리브 이전에 미나를 떠나는 것이 허용됩니다. 나파르 사니: 13일까지 머물며 다시 투석하는 것(이것이 더 권장됩니다).",
        "hi": "नफ़र अव्वल: 12 ज़िलहिज्जा को मग़रिब से पहले मिना छोड़ना जायज़ है। नफ़र सानी: 13 तारीख़ तक रुकना और दोबारा कंकरी मारना (यह अधिक श्रेष्ठ है)।"
      }
    ],
    "evidence": {
      "id": "QS. Al-Baqarah: 203 («Berdzikirlah pada hari-hari yang telah ditentukan...»). HR. Bukhari no. 1746–1751.",
      "en": "QS. Al-Baqarah: 203 («Remember Allah during the appointed days...»). HR. Bukhari no. 1746–1751.",
      "ar": "سورة البقرة: 203 («وَاذْكُرُوا اللَّهَ فِي أَيَّامٍ مَعْدُودَاتٍ...»). صحيح البخاري، أحاديث رقم 1746–1751.",
      "fr": "Sourate Al-Baqarah : 203 («Invoquez Allah pendant les jours déterminés...»). HR. Bukhari n° 1746–1751.",
      "de": "Sure Al-Baqarah: 203 («Gedenkt Allahs an den festgesetzten Tagen...»). HR. Bukhari Nr. 1746–1751.",
      "es": "Sura Al-Baqarah: 203 («Recordad a Allah en los días señalados...»). HR. Bukhari n.° 1746–1751.",
      "ru": "Сура Аль-Бакара: 203 («Поминайте Аллаха в считанные дни...»). Хадис. Бухари № 1746–1751.",
      "zh": "《古兰经》黄牛章（Al-Baqarah）第203节（«在规定的日子里记念真主……»）。布哈里圣训第1746–1751条。",
      "ja": "クルアーン・アル＝バカラ章：203節（«定められた日々にアッラーを念じなさい…»）。ブハーリー伝承 第1746–1751番。",
      "ko": "꾸란 알-바카라 203절 («정해진 날들에 알라를 기억하라...»). 부카리 하디스 1746–1751번.",
      "hi": "क़ुरआन सूरह अल-बक़रह: 203 («और निश्चित दिनों में अल्लाह को याद करो...»)। हदीस बुख़ारी नंबर 1746–1751।"
    }
  },
  {
    "id": "tawaf-wada",
    "day": "wada",
    "status": "wajib",
    "loc": "makkah",
    "arabic": "",
    "translit": "",
    "title": {
      "id": "Tawaf Wada' (Perpisahan)",
      "en": "Tawaf Wada' (Farewell Tawaf)",
      "ar": "طواف الوداع",
      "fr": "Tawaf Wada' (Tawaf d'adieu)",
      "de": "Tawaf Wada' (Abschiedstawaf)",
      "es": "Tawaf Wada' (Tawaf de despedida)",
      "ru": "Таваф Вада' (Прощальный таваф)",
      "zh": "告别塔瓦夫（Tawaf Wada'）",
      "ja": "タワーフ・ワダー（お別れのタワーフ）",
      "ko": "타와프 와다으 (작별 타와프)",
      "hi": "तवाफ़ वदा' (विदाई का तवाफ़)"
    },
    "body": [
      {
        "id": "Amalan terakhir sebelum meninggalkan Makkah adalah Tawaf Wada' — mengelilingi Ka'bah tujuh putaran.",
        "en": "The final act before departing Makkah is Tawaf Wada' — circumambulating the Ka'bah seven times.",
        "ar": "آخرُ عمل يؤدِّيه الحاجُّ قبل مغادرة مكةَ المكرمة هو طوافُ الوداع — وهو الطوافُ حول الكعبة المشرفة سبعةَ أشواط.",
        "fr": "Le dernier acte avant de quitter La Mecque est le Tawaf Wada' — effectuer sept tours autour de la Ka'bah.",
        "de": "Die letzte Handlung vor dem Verlassen von Makkah ist der Tawaf Wada' — die siebenmalige Umrundung der Ka'bah.",
        "es": "El último acto antes de abandonar La Meca es el Tawaf Wada' — circunvalar la Ka'bah siete veces.",
        "ru": "Последним обрядом перед отъездом из Мекки является Таваф Вада' — семикратный обход вокруг Каабы.",
        "zh": "离开麦加前的最后一项功课是告别塔瓦夫（Tawaf Wada'）——围绕克尔白（Ka'bah）转七圈。",
        "ja": "マッカを離れる前の最後の儀式はタワーフ・ワダー（お別れのタワーフ）であり、カアバ（Ka'bah）を七周します。",
        "ko": "메카를 떠나기 전 마지막 의식은 타와프 와다으로, 카으바(Ka'bah)를 일곱 바퀴 도는 것입니다.",
        "hi": "मक्का छोड़ने से पहले अंतिम अमल तवाफ़ वदा' है — काबा (Ka'bah) के सात चक्कर लगाना।"
      },
      {
        "id": "Kewajiban ini gugur bagi perempuan yang sedang haid atau nifas.",
        "en": "This obligation is waived for women who are menstruating (haid) or in postnatal bleeding (nifas).",
        "ar": "تسقط هذه الواجبُ عن المرأة الحائض أو النُّفَساء.",
        "fr": "Cette obligation est levée pour les femmes qui ont leurs menstruations (haid) ou qui sont en état de saignement post-natal (nifas).",
        "de": "Diese Pflicht entfällt für Frauen, die sich in der Menstruation (Haid) oder im Wochenbett (Nifas) befinden.",
        "es": "Esta obligación queda exenta para las mujeres que están menstruando (haid) o con sangrado posparto (nifas).",
        "ru": "Данная обязанность снимается с женщин, находящихся в состоянии менструации (хайд) или послеродового кровотечения (нифас).",
        "zh": "正处于月经（haid）或产后出血（nifas）期间的女性可免除此义务。",
        "ja": "この義務は、月経中（ハイド）または産後出血中（ニファース）の女性には免除されます。",
        "ko": "이 의무는 생리 중(하이드)이거나 산후 출혈 중(니파스)인 여성에게는 면제됩니다.",
        "hi": "यह दायित्व उन महिलाओं के लिए माफ़ है जो मासिक धर्म (हैज़) या प्रसवोत्तर रक्तस्राव (निफ़ास) में हों।"
      },
      {
        "id": "Setelah Tawaf Wada', jamaah hendaknya tidak berlama-lama tinggal di Makkah.",
        "en": "After performing Tawaf Wada', pilgrims should not linger long in Makkah.",
        "ar": "بعد أداء طواف الوداع، لا ينبغي للحجاج أن يطيلوا المكث في مكة المكرمة.",
        "fr": "Après le Tawaf Wada', les pèlerins ne doivent pas s'attarder longtemps à La Mecque.",
        "de": "Nach dem Tawaf Wada' sollten die Pilger nicht lange in Makkah verweilen.",
        "es": "Después del Tawaf Wada', los peregrinos no deben permanecer mucho tiempo en La Meca.",
        "ru": "После совершения Тавафа Вада' паломникам не следует задерживаться в Мекке.",
        "zh": "完成辞别塔瓦夫（Tawaf Wada'）后，朝觐者不应在麦加久留。",
        "ja": "タワーフ・ワダー（Tawaf Wada'）を終えた後、巡礼者はマッカに長く留まるべきではありません。",
        "ko": "타와프 와다(Tawaf Wada')를 마친 후, 순례자들은 마카에 오래 머물지 않아야 합니다.",
        "hi": "Tawaf Wada' अदा करने के बाद, हाजियों को मक्का में अधिक देर नहीं रुकना चाहिए।"
      }
    ],
    "evidence": {
      "id": "«Jangan seorang pun pulang sebelum menjadikan tawaf di Baitullah sebagai amalan terakhirnya» (HR. Muslim no. 1327).",
      "en": "\"Let no one depart until he makes Tawaf around the House (Ka'bah) his last act\" (HR. Muslim no. 1327).",
      "ar": "«لَا يَنْفِرَنَّ أَحَدٌ حَتَّى يَكُونَ آخِرُ عَهْدِهِ بِالْبَيْتِ» (رواه مسلم رقم ١٣٢٧).",
      "fr": "« Que nul ne reparte avant d'avoir fait du Tawaf autour de la Maison (Ka'bah) son dernier acte » (HR. Muslim n° 1327).",
      "de": "„Niemand soll abreisen, bevor er den Tawaf um das Haus (Ka'bah) zu seiner letzten Handlung gemacht hat\" (HR. Muslim Nr. 1327).",
      "es": "«Que nadie se marche hasta que haya hecho del Tawaf alrededor de la Casa (Ka'bah) su último acto» (HR. Muslim n.º 1327).",
      "ru": "«Пусть никто не уходит, пока не совершит Таваф вокруг Дома (Каабы) последним своим делом» (HR. Muslim № 1327).",
      "zh": "「任何人不得离开，直到以围绕天房（Ka'bah）的塔瓦夫作为其最后的功课。」（穆斯林圣训集第1327条）",
      "ja": "「誰も、バイトゥッラー（Ka'bah）のタワーフを最後の行いとするまで帰ってはならない」（HR. Muslim no. 1327）。",
      "ko": "\"누구도 바이툴라(Ka'bah)의 타와프를 마지막 행위로 삼기 전에는 떠나지 말라\" (HR. Muslim 제1327호).",
      "hi": "«कोई भी व्यक्ति तब तक न जाए जब तक कि वह Ka'bah का Tawaf अपना अंतिम कार्य न बना ले» (HR. Muslim नं. 1327)।"
    }
  }
];

export const HAJJ_UI = {
  "pageTitle": {
    "id": "Manasik Haji: Hari demi Hari",
    "en": "Hajj Manasik: Day by Day",
    "ar": "مناسك الحج: يوماً بيوم",
    "fr": "Manasik du Hajj : Jour par Jour",
    "de": "Haji Manasik: Tag für Tag",
    "es": "Manasik del Hajj: Día a Día",
    "ru": "Манасик Хаджа: День за Днём",
    "zh": "朝觐功课：逐日指南",
    "ja": "ハッジのマナシク：日ごとのガイド",
    "ko": "하지 마나시크: 날마다",
    "hi": "हज मनासिक: दिन-ब-दिन"
  },
  "pageSub": {
    "id": "Rangkaian ibadah haji 8–13 Dzulhijjah secara lengkap: amalan, status hukum, doa, dan dalilnya.",
    "en": "The complete sequence of Hajj rituals from 8–13 Dzulhijjah: practices, legal rulings, supplications, and their evidence.",
    "ar": "السلسلة الكاملة لمناسك الحج من الثامن إلى الثالث عشر من ذي الحجة: الأعمال، والأحكام الشرعية، والأدعية، وأدلتها.",
    "fr": "La séquence complète des rites du Hajj du 8 au 13 Dzulhijjah : pratiques, statuts juridiques, invocations et leurs preuves.",
    "de": "Die vollständige Abfolge der Haji-Rituale vom 8.–13. Dzulhijjah: Praktiken, Rechtsstatus, Bittgebete und ihre Belege.",
    "es": "La secuencia completa de los rituales del Hajj del 8 al 13 de Dzulhijjah: prácticas, dictámenes legales, súplicas y sus evidencias.",
    "ru": "Полная последовательность обрядов Хаджа с 8 по 13 Зуль-хиджа: действия, правовые положения, молитвы и их доказательства.",
    "zh": "8至13日尔·黑哲月朝觐功课的完整流程：功课内容、法律裁定、祈祷词及其依据。",
    "ja": "ズルヒッジャ月8〜13日のハッジ礼拝の完全な手順：実践、法的判断、祈り、およびその根拠。",
    "ko": "8~13 줄히자의 하지 의례의 완전한 순서: 실천 사항, 법적 판결, 기도문 및 그 근거.",
    "hi": "8–13 ज़ुल-हिज्जा के हज मनासिक का पूर्ण क्रम: अमल, शरई हुक्म, दुआएं और उनके दलाइल।"
  },
  "dashLabel": {
    "id": "Haji Hari demi Hari",
    "en": "Hajj Day by Day",
    "ar": "الحج يوماً بيوم",
    "fr": "Hajj Jour par Jour",
    "de": "Haji Tag für Tag",
    "es": "Hajj Día a Día",
    "ru": "Хадж День за Днём",
    "zh": "朝觐逐日指南",
    "ja": "日ごとのハッジ",
    "ko": "날마다 하지",
    "hi": "हज दिन-ब-दिन"
  },
  "dashHint": {
    "id": "Timeline lengkap manasik haji 8–13 Dzulhijjah",
    "en": "Complete timeline of Hajj manasik from 8–13 Dzulhijjah",
    "ar": "الجدول الزمني الكامل لمناسك الحج من الثامن إلى الثالث عشر من ذي الحجة",
    "fr": "Calendrier complet des manasik du Hajj du 8 au 13 Dzulhijjah",
    "de": "Vollständiger Zeitplan der Haji-Manasik vom 8.–13. Dzulhijjah",
    "es": "Cronograma completo de los manasik del Hajj del 8 al 13 de Dzulhijjah",
    "ru": "Полный временной график манасик Хаджа с 8 по 13 Зуль-хиджа",
    "zh": "8至13日尔·黑哲月朝觐功课完整时间表",
    "ja": "ズルヒッジャ月8〜13日のハッジ・マナシクの完全なタイムライン",
    "ko": "8~13 줄히자 하지 마나시크의 완전한 일정표",
    "hi": "8–13 ज़ुल-हिज्जा के हज मनासिक की पूर्ण समय-रेखा"
  },
  "statusRukun": {
    "id": "Rukun",
    "en": "Rukun (Pillar)",
    "ar": "ركن (فرض لا يُجبر بدم)",
    "fr": "Rukun (Pilier essentiel)",
    "de": "Rukun (Pflichtpfeiler)",
    "es": "Rukun (Pilar esencial)",
    "ru": "Рукун (Столп, обязательный элемент)",
    "zh": "柱功（Rukun）",
    "ja": "ルクン（必須の柱）",
    "ko": "루쿤 (필수 기둥)",
    "hi": "रुकुन (अनिवार्य स्तंभ)"
  },
  "statusWajib": {
    "id": "Wajib",
    "en": "Wajib (Obligatory)",
    "ar": "واجب",
    "fr": "Wajib (Obligatoire)",
    "de": "Wajib (Verpflichtend)",
    "es": "Wajib (Obligatorio)",
    "ru": "Ваджиб (Обязательное действие)",
    "zh": "瓦吉布（Wajib，必须）",
    "ja": "ワージブ（義務的行為）",
    "ko": "와집 (의무 행위)",
    "hi": "वाजिब (अनिवार्य कार्य)"
  },
  "statusSunnah": {
    "id": "Sunnah",
    "en": "Sunnah (Recommended)",
    "ar": "سنة (مستحب)",
    "fr": "Sunnah (Recommandé)",
    "de": "Sunnah (Empfohlen)",
    "es": "Sunnah (Recomendado)",
    "ru": "Сунна (Желательное действие)",
    "zh": "逊奈（Sunnah，圣行，推荐）",
    "ja": "スンナ（推奨行為）",
    "ko": "순나 (권장 행위)",
    "hi": "सुन्नह (अनुशंसित कार्य)"
  },
  "whatToDo": {
    "id": "Amalan & Tata Cara",
    "en": "Practices & Procedures",
    "ar": "الأعمال والإجراءات",
    "fr": "Pratiques et procédures",
    "de": "Praktiken & Abläufe",
    "es": "Prácticas y procedimientos",
    "ru": "Обряды и порядок их совершения",
    "zh": "功课与步骤",
    "ja": "礼拝行為と手順",
    "ko": "실천 사항 및 절차",
    "hi": "अमल और तरीका-ए-कार"
  },
  "duaLabel": {
    "id": "Doa / Dzikir",
    "en": "Du'a / Dhikr",
    "ar": "الدعاء / الذكر",
    "fr": "Du'a / Dhikr",
    "de": "Du'a / Dhikr",
    "es": "Du'a / Dhikr",
    "ru": "Ду'а / Зикр",
    "zh": "祈祷文 / 迪克尔（Dhikr）",
    "ja": "ドゥアー / ズィクル",
    "ko": "두아 / 디크르",
    "hi": "दुआ / ज़िक्र"
  },
  "evidenceLabel": {
    "id": "Dalil",
    "en": "Evidence (Dalil)",
    "ar": "الدليل",
    "fr": "Preuve (Dalil)",
    "de": "Beleg (Dalil)",
    "es": "Evidencia (Dalil)",
    "ru": "Довод (Далиль)",
    "zh": "依据（Dalil）",
    "ja": "根拠（ダリール）",
    "ko": "근거 (달릴)",
    "hi": "दलील (प्रमाण)"
  },
  "viewMap": {
    "id": "Lihat di Peta",
    "en": "View on Map",
    "ar": "عرض على الخريطة",
    "fr": "Voir sur la carte",
    "de": "Auf der Karte anzeigen",
    "es": "Ver en el mapa",
    "ru": "Посмотреть на карте",
    "zh": "在地图上查看",
    "ja": "地図で見る",
    "ko": "지도에서 보기",
    "hi": "नक्शे पर देखें"
  },
  "narrateBtn": {
    "id": "Dengarkan Langkah",
    "en": "Listen to the Steps",
    "ar": "استمع إلى الخطوات",
    "fr": "Écouter les étapes",
    "de": "Schritte anhören",
    "es": "Escuchar los pasos",
    "ru": "Прослушать шаги",
    "zh": "收听步骤",
    "ja": "手順を聞く",
    "ko": "단계 듣기",
    "hi": "चरण सुनें"
  },
  "mapTitle": {
    "id": "Peta Perjalanan Manasik",
    "en": "Manasik Journey Map",
    "ar": "خريطة رحلة المناسك",
    "fr": "Carte du parcours des Manasik",
    "de": "Manasik-Reisekarte",
    "es": "Mapa del recorrido de los Manasik",
    "ru": "Карта маршрута Манасик",
    "zh": "朝觐功课旅程地图",
    "ja": "マナーシク巡礼旅程マップ",
    "ko": "마나시크 여정 지도",
    "hi": "मनासिक यात्रा का नक्शा"
  },
  "mapHint": {
    "id": "Lokasi utama haji: Makkah, Mina, Muzdalifah, Arafah, dan Jamarat.",
    "en": "Key Hajj locations: Makkah, Mina, Muzdalifah, Arafah, and Jamarat.",
    "ar": "المواقع الرئيسية للحج: مكة المكرمة، منى، مزدلفة، عرفات، والجمرات.",
    "fr": "Lieux clés du Hajj : La Mecque, Mina, Muzdalifah, Arafah et Jamarat.",
    "de": "Wichtige Hajj-Orte: Makkah, Mina, Muzdalifah, Arafah und Jamarat.",
    "es": "Lugares clave del Hajj: La Meca, Mina, Muzdalifah, Arafah y Jamarat.",
    "ru": "Ключевые места Хаджа: Макка, Мина, Муздалифа, Арафат и Джамарат.",
    "zh": "朝觐主要地点：麦加、米纳、穆兹代里法、阿拉法特和贾马拉特。",
    "ja": "ハッジの主要地：マッカ、ミナー、ムズダリファ、アラファート、ジャマラート。",
    "ko": "하지 주요 장소: 마카, 미나, 무즈달리파, 아라파트, 자마라트.",
    "hi": "हज के प्रमुख स्थान: मक्का, मिना, मुज़्दलिफ़ा, अरफ़ात और जमरात।"
  },
  "mapLegendTitle": {
    "id": "Jarak dari Masjidil Haram (garis lurus)",
    "en": "Distance from Masjidil Haram (straight line)",
    "ar": "المسافة من المسجد الحرام (خط مستقيم)",
    "fr": "Distance de la Masjidil Haram (ligne droite)",
    "de": "Entfernung von der Masjidil Haram (Luftlinie)",
    "es": "Distancia desde la Masjidil Haram (línea recta)",
    "ru": "Расстояние от Масджидуль-Харам (по прямой)",
    "zh": "距麦斯吉德·哈拉姆的距离（直线）",
    "ja": "マスジドゥル・ハラームからの距離（直線）",
    "ko": "마스지딜 하람으로부터의 거리 (직선)",
    "hi": "मस्जिदुल हराम से दूरी (सीधी रेखा)"
  },
  "directionsLabel": {
    "id": "Rute Google Maps",
    "en": "Google Maps Route",
    "ar": "مسار خرائط جوجل",
    "fr": "Itinéraire Google Maps",
    "de": "Google Maps-Route",
    "es": "Ruta de Google Maps",
    "ru": "Маршрут в Google Maps",
    "zh": "谷歌地图路线",
    "ja": "Googleマップのルート",
    "ko": "구글 지도 경로",
    "hi": "गूगल मैप्स मार्ग"
  },
  "kmLabel": {
    "id": "km",
    "en": "km",
    "ar": "كم",
    "fr": "km",
    "de": "km",
    "es": "km",
    "ru": "км",
    "zh": "公里",
    "ja": "km",
    "ko": "km",
    "hi": "किमी"
  },
  "loc.makkah": {
    "id": "Masjidil Haram (Makkah)",
    "en": "Masjidil Haram (Makkah)",
    "ar": "المسجد الحرام (مكة المكرمة)",
    "fr": "Masjidil Haram (La Mecque)",
    "de": "Masjidil Haram (Mekka)",
    "es": "Masjidil Haram (La Meca)",
    "ru": "Масджидул-Харам (Мекка)",
    "zh": "禁寺（麦加）",
    "ja": "マスジドゥル・ハラーム（マッカ）",
    "ko": "마스지딜 하람 (마카)",
    "hi": "मस्जिदुल हराम (मक्का)"
  },
  "loc.mina": {
    "id": "Mina",
    "en": "Mina",
    "ar": "منى",
    "fr": "Mina",
    "de": "Mina",
    "es": "Mina",
    "ru": "Мина",
    "zh": "米纳",
    "ja": "ミナー",
    "ko": "미나",
    "hi": "मिना"
  },
  "loc.muzdalifah": {
    "id": "Muzdalifah",
    "en": "Muzdalifah",
    "ar": "مزدلفة",
    "fr": "Muzdalifah",
    "de": "Muzdalifah",
    "es": "Muzdalifah",
    "ru": "Муздалифа",
    "zh": "穆兹达利法",
    "ja": "ムズダリファ",
    "ko": "무즈달리파",
    "hi": "मुज़्दलिफ़ा"
  },
  "loc.arafah": {
    "id": "Arafah (Jabal Rahmah)",
    "en": "Arafah (Jabal Rahmah)",
    "ar": "عرفة (جبل الرحمة)",
    "fr": "Arafah (Jabal Rahmah)",
    "de": "Arafah (Jabal Rahmah)",
    "es": "Arafah (Jabal Rahmah)",
    "ru": "Арафа (Джабаль Рахма)",
    "zh": "阿拉法特（仁慈山）",
    "ja": "アラファー（ジャバル・ラフマ）",
    "ko": "아라파 (자발 라흐마)",
    "hi": "अरफ़ाह (जबल रहमा)"
  },
  "loc.jamarat": {
    "id": "Jamarat (Mina)",
    "en": "Jamarat (Mina)",
    "ar": "الجمرات (منى)",
    "fr": "Jamarat (Mina)",
    "de": "Jamarat (Mina)",
    "es": "Jamarat (Mina)",
    "ru": "Джамарат (Мина)",
    "zh": "贾马拉特（米纳）",
    "ja": "ジャマラート（ミナー）",
    "ko": "자마라트 (미나)",
    "hi": "जमरात (मिना)"
  },
  "day8": {
    "id": "8 Dzulhijjah",
    "en": "8 Dhul Hijjah",
    "ar": "٨ ذو الحجة",
    "fr": "8 Dhou Al-Hijja",
    "de": "8. Dhul Hiddscha",
    "es": "8 Dhul Hiyya",
    "ru": "8 Зуль-Хиджа",
    "zh": "斋月十二月8日（朱勒·海贾月8日）",
    "ja": "ズルヒッジャ月8日",
    "ko": "줄히자 8일",
    "hi": "8 ज़ुल-हिज्जा"
  },
  "day9": {
    "id": "9 Dzulhijjah",
    "en": "9 Dhul Hijjah",
    "ar": "٩ ذو الحجة",
    "fr": "9 Dhou Al-Hijja",
    "de": "9. Dhul Hiddscha",
    "es": "9 Dhul Hiyya",
    "ru": "9 Зуль-Хиджа",
    "zh": "朱勒·海贾月9日",
    "ja": "ズルヒッジャ月9日",
    "ko": "줄히자 9일",
    "hi": "9 ज़ुल-हिज्जा"
  },
  "day10": {
    "id": "10 Dzulhijjah — Nahr",
    "en": "10 Dhul Hijjah — Nahr",
    "ar": "١٠ ذو الحجة — النحر",
    "fr": "10 Dhou Al-Hijja — Nahr",
    "de": "10. Dhul Hiddscha — Nahr",
    "es": "10 Dhul Hiyya — Nahr",
    "ru": "10 Зуль-Хиджа — Нахр",
    "zh": "朱勒·海贾月10日——宰牲日（Nahr）",
    "ja": "ズルヒッジャ月10日 — ナフル（Nahr）",
    "ko": "줄히자 10일 — 나흐르(Nahr)",
    "hi": "10 ज़ुल-हिज्जा — नहर (Nahr)"
  },
  "daytasyrik": {
    "id": "11–13 Dzulhijjah — Tasyrik",
    "en": "11–13 Dhul Hijjah — Tasyrik",
    "ar": "١١–١٣ ذو الحجة — أيام التشريق",
    "fr": "11–13 Dhou Al-Hijja — Tasyrik",
    "de": "11.–13. Dhul Hiddscha — Tasyrik",
    "es": "11–13 Dhul Hiyya — Tasyrik",
    "ru": "11–13 Зуль-Хиджа — Ташрик",
    "zh": "朱勒·海贾月11–13日——塔什里克日（Tasyrik）",
    "ja": "ズルヒッジャ月11～13日 — タシュリーク（Tasyrik）",
    "ko": "줄히자 11–13일 — 타쉬리크(Tasyrik)",
    "hi": "11–13 ज़ुल-हिज्जा — तश्रीक (Tasyrik)"
  },
  "daywada": {
    "id": "Kepulangan",
    "en": "Departure",
    "ar": "العودة والوداع",
    "fr": "Retour",
    "de": "Abreise",
    "es": "Regreso",
    "ru": "Отъезд",
    "zh": "返程",
    "ja": "帰国",
    "ko": "귀환",
    "hi": "वापसी"
  },
  "locBtn": {
    "id": "Lokasi Saya",
    "en": "My Location",
    "ar": "موقعي",
    "fr": "Ma position",
    "de": "Mein Standort",
    "es": "Mi ubicación",
    "ru": "Моё местоположение",
    "zh": "我的位置",
    "ja": "現在地",
    "ko": "내 위치",
    "hi": "मेरा स्थान"
  },
  "locBtnOff": {
    "id": "Matikan Lokasi",
    "en": "Turn Off Location",
    "ar": "إيقاف الموقع",
    "fr": "Désactiver la position",
    "de": "Standort deaktivieren",
    "es": "Desactivar ubicación",
    "ru": "Отключить геолокацию",
    "zh": "关闭位置",
    "ja": "位置情報をオフにする",
    "ko": "위치 끄기",
    "hi": "स्थान बंद करें"
  },
  "locSearching": {
    "id": "Mencari posisi Anda…",
    "en": "Searching for your position…",
    "ar": "جارٍ البحث عن موقعك…",
    "fr": "Recherche de votre position…",
    "de": "Suche nach Ihrem Standort…",
    "es": "Buscando su posición…",
    "ru": "Поиск вашего местоположения…",
    "zh": "正在搜索您的位置…",
    "ja": "現在地を検索中…",
    "ko": "위치를 검색 중…",
    "hi": "आपकी स्थिति खोजी जा रही है…"
  },
  "locNear": {
    "id": "Anda berada di sekitar {station}",
    "en": "You are near {station}",
    "ar": "أنتَ بالقرب من {station}",
    "fr": "Vous êtes près de {station}",
    "de": "Sie befinden sich in der Nähe von {station}",
    "es": "Usted está cerca de {station}",
    "ru": "Вы находитесь вблизи {station}",
    "zh": "您在 {station} 附近",
    "ja": "あなたは {station} の近くにいます",
    "ko": "현재 {station} 근처에 있습니다",
    "hi": "आप {station} के पास हैं"
  },
  "locFar": {
    "id": "Anda {km} km dari Makkah — belum berada di kawasan manasik.",
    "en": "You are {km} km from Makkah — not yet within the manasik area.",
    "ar": "أنتَ على بُعد {km} كم من مكة المكرمة — ولم تصل بعد إلى نطاق المناسك.",
    "fr": "Vous êtes à {km} km de La Mecque — vous n'êtes pas encore dans la zone des manasik.",
    "de": "Sie sind {km} km von Makkah entfernt — noch nicht im Manasik-Bereich.",
    "es": "Usted está a {km} km de La Meca — aún no se encuentra en la zona de manasik.",
    "ru": "Вы находитесь в {km} км от Мекки — вы ещё не в зоне манасик.",
    "zh": "您距离麦加 {km} 公里——尚未进入礼仪区域（manasik）。",
    "ja": "あなたはマッカから {km} km の距離にいます — まだマナーシク区域内にいません。",
    "ko": "현재 메카에서 {km} km 떨어져 있습니다 — 아직 마나식 구역 안에 있지 않습니다.",
    "hi": "आप मक्का से {km} किमी दूर हैं — अभी मनासिक क्षेत्र में नहीं हैं।"
  },
  "locViewStep": {
    "id": "Lihat langkah",
    "en": "View step",
    "ar": "عرض الخطوة",
    "fr": "Voir l'étape",
    "de": "Schritt anzeigen",
    "es": "Ver paso",
    "ru": "Просмотреть шаг",
    "zh": "查看步骤",
    "ja": "ステップを見る",
    "ko": "단계 보기",
    "hi": "चरण देखें"
  },
  "locDenied": {
    "id": "Akses lokasi ditolak. Aktifkan izin lokasi di pengaturan browser/ponsel Anda, lalu ketuk Lokasi Saya lagi.",
    "en": "Location access denied. Enable location permission in your browser/phone settings, then tap My Location again.",
    "ar": "تم رفض الوصول إلى الموقع. فعِّل إذن الموقع في إعدادات المتصفح/الهاتف، ثم اضغط على موقعي مرة أخرى.",
    "fr": "Accès à la localisation refusé. Activez la permission de localisation dans les paramètres de votre navigateur/téléphone, puis appuyez à nouveau sur Ma position.",
    "de": "Standortzugriff verweigert. Aktivieren Sie die Standortberechtigung in Ihren Browser-/Telefoneinstellungen und tippen Sie dann erneut auf Mein Standort.",
    "es": "Acceso a la ubicación denegado. Active el permiso de ubicación en la configuración de su navegador/teléfono y luego toque Mi ubicación nuevamente.",
    "ru": "Доступ к местоположению запрещён. Включите разрешение на определение местоположения в настройках браузера/телефона, затем снова нажмите «Моё местоположение».",
    "zh": "位置访问被拒绝。请在浏览器/手机设置中启用位置权限，然后再次点击\"我的位置\"。",
    "ja": "位置情報へのアクセスが拒否されました。ブラウザ/スマートフォンの設定で位置情報の許可を有効にしてから、「現在地」をもう一度タップしてください。",
    "ko": "위치 접근이 거부되었습니다. 브라우저/휴대폰 설정에서 위치 권한을 활성화한 후 내 위치를 다시 누르세요.",
    "hi": "स्थान पहुँच अस्वीकृत। अपने ब्राउज़र/फ़ोन की सेटिंग में स्थान की अनुमति सक्षम करें, फिर मेरा स्थान पर फिर से टैप करें।"
  },
  "locUnavailable": {
    "id": "GPS tidak tersedia di perangkat ini.",
    "en": "GPS is not available on this device.",
    "ar": "نظام تحديد المواقع (GPS) غير متاح على هذا الجهاز.",
    "fr": "Le GPS n'est pas disponible sur cet appareil.",
    "de": "GPS ist auf diesem Gerät nicht verfügbar.",
    "es": "El GPS no está disponible en este dispositivo.",
    "ru": "GPS недоступен на этом устройстве.",
    "zh": "此设备不支持GPS。",
    "ja": "このデバイスではGPSは利用できません。",
    "ko": "이 기기에서는 GPS를 사용할 수 없습니다.",
    "hi": "इस डिवाइस पर GPS उपलब्ध नहीं है।"
  },
  "locPractice": {
    "id": "Mode Latihan",
    "en": "Practice Mode",
    "ar": "وضع التدريب",
    "fr": "Mode Entraînement",
    "de": "Übungsmodus",
    "es": "Modo Práctica",
    "ru": "Режим практики",
    "zh": "练习模式",
    "ja": "練習モード",
    "ko": "연습 모드",
    "hi": "अभ्यास मोड"
  },
  "locPracticeHint": {
    "id": "Pilih stasiun untuk mensimulasikan posisi Anda dan berlatih membaca peta sebelum berangkat.",
    "en": "Select a station to simulate your position and practice reading the map before you depart.",
    "ar": "اختر محطة لمحاكاة موقعك وتدرَّب على قراءة الخريطة قبل المغادرة.",
    "fr": "Sélectionnez une station pour simuler votre position et vous entraîner à lire la carte avant de partir.",
    "de": "Wählen Sie eine Station aus, um Ihre Position zu simulieren und das Kartenlesen vor der Abreise zu üben.",
    "es": "Seleccione una estación para simular su posición y practicar la lectura del mapa antes de partir.",
    "ru": "Выберите станцию, чтобы смоделировать своё местоположение и потренироваться читать карту перед отправлением.",
    "zh": "选择一个站点来模拟您的位置，并在出发前练习阅读地图。",
    "ja": "出発前に、駅を選択して位置をシミュレートし、地図の読み方を練習してください。",
    "ko": "출발 전에 스테이션을 선택하여 위치를 시뮬레이션하고 지도 읽기를 연습하세요.",
    "hi": "प्रस्थान से पहले अपनी स्थिति अनुकरण करने और मानचित्र पढ़ने का अभ्यास करने के लिए एक स्टेशन चुनें।"
  },
  "locPracticeOn": {
    "id": "Latihan: posisi disimulasikan",
    "en": "Practice: position simulated",
    "ar": "التدريب: الموقع محاكى",
    "fr": "Entraînement : position simulée",
    "de": "Übung: Position simuliert",
    "es": "Práctica: posición simulada",
    "ru": "Практика: позиция смоделирована",
    "zh": "练习：位置已模拟",
    "ja": "練習中：位置をシミュレート中",
    "ko": "연습: 위치 시뮬레이션 중",
    "hi": "अभ्यास: स्थिति अनुकरणीय है"
  },
  "locPracticeOff": {
    "id": "Keluar Mode Latihan",
    "en": "Exit Practice Mode",
    "ar": "الخروج من وضع التدريب",
    "fr": "Quitter le mode Entraînement",
    "de": "Übungsmodus beenden",
    "es": "Salir del Modo Práctica",
    "ru": "Выйти из режима практики",
    "zh": "退出练习模式",
    "ja": "練習モードを終了する",
    "ko": "연습 모드 종료",
    "hi": "अभ्यास मोड से बाहर निकलें"
  },
  "locYou": {
    "id": "Posisi Anda",
    "en": "Your Position",
    "ar": "موضعك",
    "fr": "Votre Position",
    "de": "Ihre Position",
    "es": "Su Posición",
    "ru": "Ваше Местоположение",
    "zh": "您的位置",
    "ja": "あなたの位置",
    "ko": "현재 위치",
    "hi": "आपकी स्थिति"
  },
  "arrived": {
    "id": "Anda telah tiba di {station}",
    "en": "You have arrived at {station}",
    "ar": "لقد وصلت إلى {station}",
    "fr": "Vous êtes arrivé à {station}",
    "de": "Sie sind an {station} angekommen",
    "es": "Ha llegado a {station}",
    "ru": "Вы прибыли в {station}",
    "zh": "您已抵达{station}",
    "ja": "{station}に到着しました",
    "ko": "{station}에 도착하셨습니다",
    "hi": "आप {station} पर पहुँच गए हैं"
  },
  "voiceToggle": {
    "id": "Pengumuman suara saat tiba",
    "en": "Voice announcement upon arrival",
    "ar": "إعلان صوتي عند الوصول",
    "fr": "Annonce vocale à l'arrivée",
    "de": "Sprachansage bei Ankunft",
    "es": "Anuncio de voz al llegar",
    "ru": "Голосовое объявление по прибытии",
    "zh": "到达时语音播报",
    "ja": "到着時の音声アナウンス",
    "ko": "도착 시 음성 안내",
    "hi": "पहुँचने पर आवाज़ की सूचना"
  },
  "dir.N": {
    "id": "Utara",
    "en": "North",
    "ar": "شمال",
    "fr": "Nord",
    "de": "Norden",
    "es": "Norte",
    "ru": "Север",
    "zh": "北",
    "ja": "北",
    "ko": "북",
    "hi": "उत्तर"
  },
  "dir.NE": {
    "id": "Timur Laut",
    "en": "Northeast",
    "ar": "شمال شرق",
    "fr": "Nord-Est",
    "de": "Nordosten",
    "es": "Noreste",
    "ru": "Северо-Восток",
    "zh": "东北",
    "ja": "北東",
    "ko": "북동",
    "hi": "उत्तर-पूर्व"
  },
  "dir.E": {
    "id": "Timur",
    "en": "East",
    "ar": "شرق",
    "fr": "Est",
    "de": "Osten",
    "es": "Este",
    "ru": "Восток",
    "zh": "东",
    "ja": "東",
    "ko": "동",
    "hi": "पूर्व"
  },
  "dir.SE": {
    "id": "Tenggara",
    "en": "Southeast",
    "ar": "جنوب شرق",
    "fr": "Sud-Est",
    "de": "Südosten",
    "es": "Sureste",
    "ru": "Юго-Восток",
    "zh": "东南",
    "ja": "南東",
    "ko": "남동",
    "hi": "दक्षिण-पूर्व"
  },
  "dir.S": {
    "id": "Selatan",
    "en": "South",
    "ar": "جنوب",
    "fr": "Sud",
    "de": "Süden",
    "es": "Sur",
    "ru": "Юг",
    "zh": "南",
    "ja": "南",
    "ko": "남",
    "hi": "दक्षिण"
  },
  "dir.SW": {
    "id": "Barat Daya",
    "en": "Southwest",
    "ar": "جنوب غرب",
    "fr": "Sud-Ouest",
    "de": "Südwesten",
    "es": "Suroeste",
    "ru": "Юго-Запад",
    "zh": "西南",
    "ja": "南西",
    "ko": "남서",
    "hi": "दक्षिण-पश्चिम"
  },
  "dir.W": {
    "id": "Barat",
    "en": "West",
    "ar": "غرب",
    "fr": "Ouest",
    "de": "Westen",
    "es": "Oeste",
    "ru": "Запад",
    "zh": "西",
    "ja": "西",
    "ko": "서",
    "hi": "पश्चिम"
  },
  "dir.NW": {
    "id": "Barat Laut",
    "en": "Northwest",
    "ar": "شمال غرب",
    "fr": "Nord-Ouest",
    "de": "Nordwesten",
    "es": "Noroeste",
    "ru": "Северо-Запад",
    "zh": "西北",
    "ja": "北西",
    "ko": "북서",
    "hi": "उत्तर-पश्चिम"
  },
  "disclaimer": {
    "id": "Materi mengikuti pendapat mayoritas ulama; tetaplah mengikuti bimbingan pembimbing/ustadz rombongan Anda.",
    "en": "This content follows the opinion of the majority of scholars; always follow the guidance of your group's guide or ustadh.",
    "ar": "المحتوى يتبع رأي جمهور العلماء؛ يُرجى الالتزام دائمًا بتوجيهات المرشد أو الأستاذ المرافق لمجموعتكم.",
    "fr": "Ce contenu suit l'avis de la majorité des savants ; suivez toujours les orientations du guide ou de l'ustadh de votre groupe.",
    "de": "Diese Inhalte folgen der Meinung der Mehrheit der Gelehrten; folgen Sie stets der Anleitung des Reiseleiters oder Ustadh Ihrer Gruppe.",
    "es": "Este contenido sigue la opinión de la mayoría de los eruditos; siga siempre la orientación del guía o ustadh de su grupo.",
    "ru": "Материал основан на мнении большинства учёных; всегда следуйте наставлениям руководителя или устаза вашей группы.",
    "zh": "本内容依据多数学者的意见；请始终遵循您所在团队的向导或乌斯塔兹的指导。",
    "ja": "このコンテンツは多数派の学者の意見に基づいています。常にグループのガイドまたはウスタズの指導に従ってください。",
    "ko": "이 내용은 다수 학자들의 의견을 따릅니다; 항상 귀하의 그룹 가이드 또는 우스타즈의 안내를 따르십시오.",
    "hi": "यह सामग्री बहुसंख्यक उलमा की राय पर आधारित है; हमेशा अपने समूह के गाइड या उस्ताज़ के मार्गदर्शन का पालन करें।"
  }
};
